import moment from "moment";
import React, { useEffect, useState } from "react";
import Calendar from "react-calendar";
import {
  useCancelAppointmentMutation,
  useFetchAppointmentsMutation,
  useFetchAppointmentTypesMutation,
  useFetchConsolidatedAppointmentsMutation,
  useFetchMapProvidersMutation,
  useFilterAppointmentOptionsMutation,
  useGetAppointmentCountMutation,
  useLockAppointmentMutation,
  useOptimiseDayMutation,
  useRescheduleAppointmentMutation,
  useUpdateAppointmentMutation,
  useUpdateAppointmentStatusMutation,
  useUpdateAppointmentTimeslotMutation,
  useUpdateBulkAppointmentTimeslotMutation,
} from "../../features/appointment/appointmentApiSlice";
import { useGetProviderAvailabilityMutation } from "../../features/provider/providerApiSlice";
import classNames from "classnames";
import { useSelector } from "react-redux";
import { selectToken, selectUser } from "../../features/auth/authSlice";
import Unlock from "../../assets/svgs/Unlock";
import Lock from "../../assets/svgs/Lock";
import CheckSvg from "../../assets/svgs/CheckSvg";
import LeftArrowSvg from "../../assets/svgs/LeftArrowSvg";
import Tabs from "../../components/Tabs";
import Map from "../../components/Maps/Map";
import { useMapStore } from "../../context/map.store";
import {
  avatarName,
  capitalizeFirstWords,
  getSlotsAvailable,
  numberToPhone,
} from "../../utilities/resuseFunctions";
import axios from "axios";
import { useLSStore } from "../../context/ls-store";
import AppointmentSelectModal from "../LongitudinalSchedules/components/AppointmentSelectModal";
import AppointmentCancelModal from "../LongitudinalSchedules/components/AppointmentCancelModal";
import Dropdown from "../../assets/svgs/Dropdown";
import Download from "../../assets/svgs/Download";
import UserSvg from "../../assets/svgs/user";
import {
  Edit_Icon,
  Search_Icon,
  Sort_Icon,
  User_Icon,
  Users_Icon,
} from "../../assets/images";
import UsersSvg from "../../assets/svgs/UsersSvg";
import CloseSvg from "../../assets/svgs/CloseSvg";
import AppointmentLockModal from "../LongitudinalSchedules/components/AppointmentLockModal";
import { DropArea } from "../LongitudinalSchedules/components/DropArea";
import { flushSync } from "react-dom";
import { Delete } from "@mui/icons-material";
import AppointmentAddModal from "../LongitudinalSchedules/components/AppointmentAddModal";
import Chat from "../Chat/Chat";
import SelectableButton from "../../components/Buttons/SelectableButton";
import CustomButton from "../../components/Buttons/CustomButton";
import PublishAppointmentModal from "../LongitudinalSchedules/components/PublishAppointmentModal";
import Loading from "../../components/Loading";
import { IconButton, Menu, MenuItem, Tooltip } from "@mui/material";
import {
  useGetDepartmentsMutation,
  useSaveMetadataMutation,
} from "../../features/organisation/organisationApiSlice";
import { useFetchZonesMutation } from "../../features/zones/zonesApiSlice";
import AppointmentStatusModal from "../LongitudinalSchedules/components/AppointmentStatusModal";
import { Icon } from "@virtuslab/tetrisly-icons";
import VisitCancelModal from "../../components/Modals/VisitCancelModal";
import {
  ACTIVITY_STATUS,
  ACTIVITY_TYPE,
  APPOINTMENT_CREATED_FROM,
} from "../../constants/config.constants";
import { useCreateLogsMutation } from "../../features/logs/logsApiSlice";
import AppointmentConflictModal from "../LongitudinalSchedules/components/AppointmentConflictModal";
import AppointmentSequence from "../LongitudinalSchedules/components/AppointmentSequence";
import Optimise from "../../assets/svgs/Optimise";
import ReusableModal from "../../components/Modals/ReusableModal";
import { BsLightningChargeFill } from "react-icons/bs";
import InfoModal from "../../components/Modals/InfoModal";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useEffectSkipFirst } from "../../hooks/useEffectSkipFirst";
import { formatTime } from "../PatientSchedulingWizard/components/AppointmentCard";
import BulkActionsModal from "../LongitudinalSchedules/components/BulkActionsModal";
import InfoSvg from "../../assets/svgs/InfoSvg";
import tzlookup from "tz-lookup";
import { LEAVE_TYPE } from "../Schedules/Configure/ProvidersConfig/components/ProviderSettingsModal";

const CommandCenterV2 = () => {
  const navigate = useNavigate();
  const [startDate, setStartDate] = React.useState(
    moment().startOf("month").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = React.useState(
    moment().endOf("month").format("YYYY-MM-DD")
  );

  const [selectedDate, setSelectedDate] = React.useState(moment().toDate());
  const [count, setCount] = React.useState([]);
  const [selectedProvider, setSelectedProvider] = React.useState(null);
  const [selectedTab, setSelectedTab] = React.useState("Scheduler");
  const [isPublish, setIsPublish] = useState(false);
  const [weeks, setWeeks] = useState(null);
  const [successCard, setSuccessCard] = useState(false);

  const [appointments, setAppointments] = React.useState([]);
  const [consolidatedAppointments, setConsolidatedAppointments] =
    React.useState([]);
  const [recallSchedule, setRecallSchedule] = useState(false);
  const [openCancelModal, setOpenCancelModal] = useState(false);
  const [openLockModal, setOpenLockModal] = useState(false);
  const [appointmentToCancel, setAppointmentToCancel] = useState(null);
  const [appointmentToLock, setAppointmentToLock] = useState(null);
  const [draggingAppointment, setDraggingAppointment] = useState(null);
  const [targetIndex, setTargetIndex] = useState(null);
  const [editable, setEditable] = useState(false);
  const [timeslots, setTimeslots] = useState([]);

  const [addOpen, setAddOpen] = useState(false);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [appointmentToChangeStatus, setAppointmentToChangeStatus] =
    useState(null);
  const [appointmentToChangeTimeslot, setAppointmentToChangeTimeslot] =
    useState(null);

  const [filterOptions, setFilterOptions] = useState(null);

  const [showProviderList, setShowProviderList] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [appointmentsSelected, setAppointmentsSelected] = useState([]);
  const [showError, setShowError] = useState(null);
  const [showLockedError, setShowLockedError] = useState(null);
  const [timeslotEditConfirmation, setTimeslotEditConfirmation] =
    useState(null);
  const [visitTypeEditConfirmation, setVisitTypeEditConfirmation] =
    useState(null);
  const [departments, setDepartments] = React.useState([]);
  const [appointmentTypes, setAppointmentTypes] = React.useState([]);
  const [error, setError] = React.useState(null);
  const [primaryTitle, setPrimaryTitle] = React.useState("Yes");
  const [secondaryTitle, setSecondaryTitle] = React.useState("No");
  const [providerTimezone, setProviderTimezone] = useState(null);
  const [availability, setAvailability] = useState([]);
  const [currentDayAvailability, setCurrentDayAvailability] = useState([]);

  const estTimezone = "America/New_York";

  const {
    providers,
    setProviders,
    providerData,
    setProviderData,
    zone,
    setZone,
  } = useMapStore((state) => state);

  const [zones, setZones] = useState([]);

  const [selectedZone, setSelectedZone] = useState(zone);
  const [zoneAnchor, setZoneAnchor] = useState(null);
  const open = Boolean(zoneAnchor);
  const zoneOpen = Boolean(zoneAnchor);

  const handleZoneClick = (event) => {
    setZoneAnchor(event.currentTarget);
  };

  const handleZoneClose = () => {
    setZoneAnchor(null);
  };

  const handleSelect = (i) => {
    handleZoneClose();
    setZone(i);
    //  !isCommunity &&
    setSelectedZone(i);
  };

  const selectedAppointment = useLSStore((state) => state.selectedAppointment);
  const setSelectedAppointment = useLSStore(
    (state) => state.setSelectedAppointment
  );

  const user = useSelector(selectUser);
  const token = useSelector(selectToken);

  const [getAppointmentCount, { isLoading: getLoading }] =
    useGetAppointmentCountMutation();
  const [fetchMapProviders, { isLoading: mapLoading }] =
    useFetchMapProvidersMutation();
  const [fetchAppointments, { isLoading: appLoading }] =
    useFetchAppointmentsMutation();
  const [fetchConsolidatedAppointmentsAPI, { isLoading: consLoading }] =
    useFetchConsolidatedAppointmentsMutation();
  const [cancelAppointment, { isLoading: cancelLoading }] =
    useCancelAppointmentMutation();
  const [lockAppointment, { isLoading: lockLoading }] =
    useLockAppointmentMutation();
  const [rescheduleAppointments, { isLoading: reschLoading }] =
    useRescheduleAppointmentMutation();
  const [filterAppointmentOptions, { isLoading: filterLoading }] =
    useFilterAppointmentOptionsMutation();
  const [updateAppointmentStatus, { isLoading: updateStatusLoading }] =
    useUpdateAppointmentStatusMutation();
  const [updateAppointmentTimeslot, { isLoading: updateTimeslotLoading }] =
    useUpdateAppointmentTimeslotMutation();
  const [
    updateBulkAppointmentTimeslot,
    { isLoading: updateBulkTimeslotLoading },
  ] = useUpdateBulkAppointmentTimeslotMutation();
  const [
    getProviderAvailability,
    { isLoading: getProviderAvailabilityLoading },
  ] = useGetProviderAvailabilityMutation();
  const [getZones] = useFetchZonesMutation();
  const [createLog] = useCreateLogsMutation();
  const [getDepartments] = useGetDepartmentsMutation();
  const [getAppointmentTypes] = useFetchAppointmentTypesMutation();
  const [updateAppointment, { isLoading: updateAppointmentLoading }] = useUpdateAppointmentMutation();

  const isLoading =
    getLoading ||
    mapLoading ||
    appLoading ||
    consLoading ||
    cancelLoading ||
    lockLoading ||
    reschLoading ||
    filterLoading ||
    updateStatusLoading ||
    updateTimeslotLoading ||
    updateBulkTimeslotLoading ||
    getProviderAvailabilityLoading ||
    updateAppointmentLoading;

  const [optimiseError, setOptimiseError] = useState(null);
  const [openOptimise, setOpenOptimise] = useState(false);
  const [openOptimiseBlocked, setOpenOptimiseBlocked] = useState(false);
  const [dataToOptimise, setDataToOptimise] = useState(null);
  const [openBulkSchedule, setOpenBulkSchedule] = useState(false);
  const [dataToBulkSchedule, setDataToBulkSchedule] = useState(null);
  const [optimiseDay, { isLoading: optimiseLoading }] =
    useOptimiseDayMutation();

  const [searchParams, setSearchParams] = useSearchParams();
  const providerSelected = searchParams.get("providerId");
  const dateSelected = searchParams.get("selectedDate");
  const appointmentSelectedParam = searchParams.get("appointmentId");

  const handleClearSelectedAppointment = () => {
    setSelectedAppointment(null);
    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      params.delete("appointmentId");
      return params;
    });
  };

  const handleOptimise = (date = null, providerId = null) => {
    if (date != null && providerId != null) {
      const hasLockedOrPublished = filteredAppointments?.some(
        (a) =>
          a.status === "LOCKED" || a.status === "PUBLISHED"
      );
      if (hasLockedOrPublished) {
        setOpenOptimiseBlocked(true);
        return;
      }
      setDataToOptimise({ date, providerId });
    }
    setOpenOptimise(!openOptimise);
    if (date == null && providerId == null) setDataToOptimise(null);
  };

  const handleOptimiseCall = async (date, providerId) => {
    try {
      setOptimiseError(null);

      await optimiseDay({
        date,
        providerId,
      }).unwrap();

      await fetchAppointmentsFunction();

      handleOptimise();
    } catch (err) {
      setOptimiseError(err?.data?.message);
    }
  };

  const fetchAppointmentCount = async () => {
    try {
      const { data } = await getAppointmentCount({
        providerId: selectedProvider?.id || 0,
        organisationId: user.organisation.id,
        startDate,
        endDate,
        fromApp: false,
        marketId: selectedProvider?.market_id
      }).unwrap();

      setCount(data);
    } catch (error) {
      console.error(error?.data?.message || error?.message);
    }
  };

  const fetchAppointmentsFunction = async () => {
    try {
      const { data } = await fetchAppointments({
        providerId: selectedProvider?.id,
        appointmentType: "all",
        locationType: "all",
        communityId: null,
        patientId: null,
        startDate: moment(selectedDate).format("YYYY-MM-DD"),
        endDate: moment(selectedDate).format("YYYY-MM-DD"),
        fromApp: false,
        marketId: selectedProvider?.market_id
      });

      setAppointments(data.data);

      const { data: mapData } = await fetchMapProviders({
        mapFor: "PATIENT",
        date: moment(selectedDate).format("YYYY-MM-DD"),
        providerId: selectedProvider?.id,
        fromApp: "false",
      });
      setProviderData(mapData?.data || []);
      fetchDepartments();
      fetchAppointmentTypes();
    } catch (err) {
      console.error(err);
    }
  };

  const fetchAppointmentsConsolidated = async () => {
    try {
      const { data } = await fetchConsolidatedAppointmentsAPI({
        organisationId: user.organisation.id,
        date: moment(selectedDate).format("YYYY-MM-DD"),
        zoneId: selectedZone.id,
      });

      setConsolidatedAppointments(data.data);
      const { data: mapData } = await fetchMapProviders({
        mapFor: "PROVIDER",
        date: moment(selectedDate).format("YYYY-MM-DD"),
        providerId: "0",
        zoneId: selectedZone.id,
        fromApp: "false",
      });
      setProviders(mapData?.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchDepartments = async () => {
    try {
      const { data } = await getDepartments(user.organisation.id).unwrap();
      setDepartments(data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchAppointmentTypes = async () => {
    try {
      const { data } = await getAppointmentTypes({
        organisationId: user.organisation.id,
        rotation: "all",
        format: "all",
        dispatch: "all",
        screen: "all",
      }).unwrap();

      setAppointmentTypes(data?.appointmentTypes);
    } catch (error) {
      console.log("error", error);
      // console.error(error.data.data.message);
    }
  };

  const downloadCSV = async () => {
    const payload = {
      activity: `Schedules downloaded for Provider ${selectedProvider?.name || ""
        } on ${moment(selectedDate).format("MMM dd, yyyy")} by User - ${user?.details?.name || ""
        }`,
      type: ACTIVITY_TYPE.DOWNLOAD_SCHEDULES,
      data: {
        providerId: selectedProvider?.id,
      },
    };
    try {
      const providerId = selectedProvider?.id;
      const name = selectedProvider?.name;
      const startDate = moment().format("YYYY-MM-DD");
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/appointment/csv?providerId=${providerId}&startDate=${startDate}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${name} (${providerId}).csv`);
      document.body.appendChild(link);
      link.click();
      await createLog({ ...payload, status: ACTIVITY_STATUS.SUCCESS }).unwrap();
    } catch (error) {
      console.error(error);
      await createLog({ ...payload, status: ACTIVITY_STATUS.FAILED }).unwrap();
    }
  };

  const onMonthChange = (val) => {
    setStartDate(moment(val.activeStartDate).format("YYYY-MM-DD"));
    setEndDate(moment(val.activeStartDate).endOf("month").format("YYYY-MM-DD"));
  };

  const onDateChange = (val) => {
    setSelectedDate(val);
  };

  const getDatesInMonth = () => {
    const startDate = moment().startOf("week").add(1, "day");
    const endDate = moment(startDate).add(60, "day");

    let currentWeek = [];
    let currentDate = startDate;

    while (currentDate <= endDate) {
      currentWeek.push({
        date: currentDate.format("YYYY-MM-DD"),
        day: currentDate.format("ddd").toUpperCase(),
      });

      currentDate = currentDate.clone().add(1, "day");
    }
    return currentWeek;
  };

  /** Working-hour times from the API are wall-clock in the provider's timezone, not Eastern. */
  const getProviderTimezoneTime = (date, time, timezone) => {
    if (!date || !time) return time;
    const padded = String(time)
      .split(":")
      .map((x) => (x.length === 1 ? `0${x}` : x))
      .join(":");
    if (timezone) {
      return moment.tz(`${date}T${padded}`, timezone).format("HH:mm");
    }
    return padded;
  };

  const getEstTimezoneTime = (date, time, timezone) => {
    if (date && time && timezone) {
      const providerDateTime = moment.tz(`${date}T${time}`, timezone);
      return providerDateTime.clone().tz(estTimezone).format("HH:mm");
    } else {
      return time;
    }
  };

  const transformedMonthlyAvailability = (availabilities) => {
    return availabilities
      ?.filter((i) => !i?.isWeeklyEv)
      ?.flatMap((availability) => {
        const {
          working_days,
          working_hours,
          appointment_type_ids,
          zip_codes,
          zone_ids,
        } = availability || {};
        const { start_time, end_time } = working_hours || {};

        return availability.dates
        ?.filter((date) => {
              const dayName = moment(date).format("dddd").toUpperCase(); // e.g., 'MONDAY'
              return working_days == null
                ? true
                : working_days.includes(dayName);
            })
        ?.map((date) => {
          const padTime = (time) =>
            time
              ?.split(":")
              ?.map((x) => (x.length === 1 ? `0${x}` : x))
              ?.join(":");

          const startTimeStr = providerTimezone
            ? getProviderTimezoneTime(date, padTime(start_time), providerTimezone)
            : padTime(start_time);

          const endTimeStr = providerTimezone
            ? getProviderTimezoneTime(date, padTime(end_time), providerTimezone)
            : padTime(end_time);

          const startDateTime = providerTimezone
            ? moment.tz(`${date}T${startTimeStr}`, providerTimezone).toDate()
            : new Date(`${date}T${startTimeStr}`);
          const endDateTime = providerTimezone
            ? moment.tz(`${date}T${endTimeStr}`, providerTimezone).toDate()
            : new Date(`${date}T${endTimeStr}`);

          const formattedStart = providerTimezone
            ? moment.tz(`${date}T${startTimeStr}`, providerTimezone).format("hh:mm A")
            : moment(startDateTime).format("hh:mm A");
          const formattedEnd = providerTimezone
            ? moment.tz(`${date}T${endTimeStr}`, providerTimezone).format("hh:mm A")
            : moment(endDateTime).format("hh:mm A");

          return {
            start: startDateTime,
            end: endDateTime,
            title: `${formattedStart} to ${formattedEnd}`,
            time_slots: [`${start_time}-${end_time}`],
            appointment_type_ids,
            zip_codes,
            zone_ids,
            dates: availability?.dates,
            isMonthlyEv: true
          };
        });
      })
  }

  const transformedWeeklySettings = (dayPreferences, workingDays, startDate) => {
    try {
      if (!dayPreferences) return [];

      const weeklyEvents = [];
      // const deletedDates = []
      const currentMonth = moment(startDate).startOf("month");
      const endOfMonth = moment(startDate).endOf("month");

      // Helper function to get day number (0-6) from day name
      const getDayNumber = (dayName) => {
        const dayMap = {
          SUNDAY: 0,
          MONDAY: 1,
          TUESDAY: 2,
          WEDNESDAY: 3,
          THURSDAY: 4,
          FRIDAY: 5,
          SATURDAY: 6,
        };
        return dayMap[dayName];
      };

      // Process each day's preferences
      if (workingDays && workingDays?.length) {
        workingDays?.forEach((day) => {
          if (day === "ALL") return; // Skip the ALL settings as they're defaults

          const preferences = dayPreferences?.[day] || dayPreferences?.["ALL"];

          if (preferences) {
            const { working_hours } = preferences || {};
            if (!working_hours?.start || !working_hours?.end) return;

            // Get all dates of this day in the current month
            let date = moment(currentMonth);
            while (date.isSameOrBefore(endOfMonth)) {
              if (date.day() === getDayNumber(day)) {
                const dateStr = date.format("YYYY-MM-DD");
                const start_time = getProviderTimezoneTime(
                  dateStr,
                  working_hours.start,
                  providerTimezone
                );
                const end_time = getProviderTimezoneTime(
                  dateStr,
                  working_hours.end,
                  providerTimezone
                );
                const startDateTime = `${dateStr}T${start_time}`;
                const endDateTime = `${dateStr}T${end_time}`;

                const formattedStart = providerTimezone
                  ? moment.tz(startDateTime, providerTimezone).format("hh:mm A")
                  : moment(startDateTime).format("hh:mm A");
                const formattedEnd = providerTimezone
                  ? moment.tz(endDateTime, providerTimezone).format("hh:mm A")
                  : moment(endDateTime).format("hh:mm A");

                if (
                  !preferences?.deleted_dates?.includes(
                    date.format("YYYY-MM-DD")
                  )
                ) {
                  weeklyEvents.push({
                    start: providerTimezone
                      ? moment.tz(startDateTime, providerTimezone).toDate()
                      : new Date(startDateTime),
                    end: providerTimezone
                      ? moment.tz(endDateTime, providerTimezone).toDate()
                      : new Date(endDateTime),
                    title: `${formattedStart} to ${formattedEnd}`,
                    time_slots: [`${start_time}-${end_time}`],
                    appointment_type_ids: preferences.appointment_type_ids,
                    zone_ids: preferences.zone_ids,
                    zip_codes: preferences.zip_codes,
                    dates: [date.format("YYYY-MM-DD")],
                    isWeeklyEv: true,
                    day: day,
                  });
                }
              }
              date = date.add(1, "day");
            }
          }
        });
      }

      return weeklyEvents;
    } catch (error) {
      console.error(error);
    }
  };

  const transformedLeaves = (leaves) => {
    return leaves?.map((leave) => {
      const startDate = moment(leave.startDate, "YYYY-MM-DD").startOf("day").toDate();
      const endDate = moment(leave.endDate, "YYYY-MM-DD").endOf("day").toDate();
      // const startTime = getProviderTimezoneTime(leave?.startDate, leave?.startTime, providerTimezone);
      // const endTime = getProviderTimezoneTime(leave?.endDate, leave?.endTime, providerTimezone);
      const startTime = leave?.startTime;
      const endTime = leave?.endTime;

      return {
        start: startDate,
        end: endDate,
        startTime: startTime,
        endTime: endTime,
        title: `Absence: ${capitalizeFirstWords(LEAVE_TYPE[leave.type].replaceAll("_", " "))
          }${leave.startTime && leave.endTime
            ? ` (${moment(startTime, "HH:mm").format("hh:mm A")} - ${moment(endTime, "HH:mm").format("hh:mm A")})`
            : ""
          }`,
        isLeave: true,
        leaveType: leave.type,
      }
    }) || [];
  }

  function generateMergedEvents(transformedMonthlyEvents = [], transformedWeeklySettings = [], transformedLeaves = [], leaves = []) {
    const getDateStr = (date) => moment(date).format("YYYY-MM-DD");

    // 1. Index all leaves by date
    const leaveMap = {};
    (leaves || []).forEach((leave) => {
      const start = moment(leave.startDate, "YYYY-MM-DD");
      const end = moment(leave.endDate, "YYYY-MM-DD");
      let current = start.clone();
      while (current.isSameOrBefore(end, "day")) {
        const dateStr = current.format("YYYY-MM-DD");
        if (!leaveMap[dateStr]) leaveMap[dateStr] = [];
        leaveMap[dateStr].push(leave);
        current.add(1, "day");
      }
    });

    // 2. Combine provider and weekly availability
    const allAvailEvents = [...(transformedMonthlyEvents || []), ...(transformedWeeklySettings || [])];

    // 3. Group availabilities by date
    const availByDate = {};
    allAvailEvents.forEach((ev) => {
      const start = moment(ev.start);
      const end = moment(ev.end);
      let current = start.clone();
      while (current.isSameOrBefore(end, "day")) {
        const dateStr = current.format("YYYY-MM-DD");
        if (!availByDate[dateStr]) availByDate[dateStr] = [];
        availByDate[dateStr].push(ev);
        current.add(1, "day");
      }
    });

    // 4. Merge logic
    let merged = [];
    const processedDates = new Set();

    Object.keys({ ...availByDate, ...leaveMap }).forEach((dateStr) => {
      processedDates.add(dateStr);
      const leavesForDay = leaveMap[dateStr] || [];
      let availsForDay = availByDate[dateStr] || [];
      const wallClock = (hhmm) =>
        providerTimezone
          ? moment.tz(`${dateStr}T${String(hhmm).trim()}`, providerTimezone)
          : moment(`${dateStr}T${String(hhmm).trim()}`);

      const monthlyEvents = availsForDay.filter(ev => ev.isMonthlyEv);
      const weeklyEvents = availsForDay.filter(ev => ev.isWeeklyEv);
      let finalAvailsForDay = [];

      if (monthlyEvents.length && weeklyEvents.length) {
        const overlaps = weeklyEvents.map(weeklyEv => {
          return monthlyEvents.some(monthlyEv => {
            const [weStartTime, weEndTime] = weeklyEv.time_slots[0].split('-');
            const [meStartTime, meEndTime] = monthlyEv.time_slots[0].split('-');
            const wStart = moment(weStartTime, 'HH:mm');
            const wEnd = moment(weEndTime, 'HH:mm');
            const mStart = moment(meStartTime, 'HH:mm');
            const mEnd = moment(meEndTime, 'HH:mm');
            return wEnd.isAfter(mStart) && wStart.isBefore(mEnd);
          });
        });

        finalAvailsForDay = [
          ...monthlyEvents,
          ...weeklyEvents.filter((ev, idx) => !overlaps[idx])
        ];
      } else {
        finalAvailsForDay = availsForDay;
      }
      availsForDay = finalAvailsForDay;

      const fullDayLeave = leavesForDay.find((l) => !l.startTime && !l.endTime);
      if (fullDayLeave) {
        const leaveEv = transformedLeaves.find(
          (ev) => getDateStr(ev.start) === dateStr && ev.isLeave
        );
        if (leaveEv) merged.push(leaveEv);
        return;
      }

      let handledAvail = new Set();
      leavesForDay.forEach((leave) => {
        if (leave.startTime && leave.endTime) {
          availsForDay.forEach((avail, idx) => {
            if (handledAvail.has(idx) || !avail.time_slots) return;
            const [availStartTime, availEndTime] = avail.time_slots[0].split('-');
            const availStart = wallClock(availStartTime);
            const availEnd = wallClock(availEndTime);
            const leaveStart = wallClock(leave.startTime);
            const leaveEnd = wallClock(leave.endTime);

            if (availEnd.isAfter(leaveStart) && availStart.isBefore(leaveEnd)) {
              if (leaveStart.isAfter(availStart)) {
                merged.push({
                  ...avail,
                  start: availStart.toDate(),
                  end: leaveStart.toDate(),
                  type: 'partial',
                  title: `${availStart.format("hh:mm A")} to ${leaveStart.format("hh:mm A")}`,
                });
              }

              const leaveEv = transformedLeaves.find(
                (ev) => getDateStr(ev.start) === dateStr && ev.isLeave &&
                  ev.startTime === leave.startTime && ev.endTime === leave.endTime
              );
              if (leaveEv) merged.push(leaveEv);

              if (leaveEnd.isBefore(availEnd)) {
                merged.push({
                  ...avail,
                  start: leaveEnd.toDate(),
                  end: availEnd.toDate(),
                  type: 'partial',
                  title: `${leaveEnd.format("hh:mm A")} to ${availEnd.format("hh:mm A")}`,
                });
              }

              handledAvail.add(idx);
            }
          });
        }
      });

      availsForDay.forEach((avail, idx) => {
        if (!handledAvail.has(idx)) merged.push(avail);
      });

      leavesForDay.forEach((leave) => {
        if (leave.startTime && leave.endTime) {
          const leaveEv = transformedLeaves.find(
            (ev) => getDateStr(ev.start) === dateStr && ev.isLeave &&
              ev.startTime === leave.startTime && ev.endTime === leave.endTime
          );
          if (leaveEv && !merged.some(ev =>
            ev.isLeave &&
            moment(ev.start).isSame(moment(leaveEv.start)) &&
            moment(ev.end).isSame(moment(leaveEv.end)) &&
            ev.startTime === leaveEv.startTime &&
            ev.endTime === leaveEv.endTime
          )) {
            merged.push(leaveEv);
          }
        }
      });
    });

    // Add any leave events not already included
    transformedLeaves.forEach((ev) => {
      const dateStr = getDateStr(ev.start);
      if (!processedDates.has(dateStr)) merged.push(ev);
    });

    // Deduplicate
    const uniqueMerged = merged.filter((event, idx, arr) =>
      idx === arr.findIndex(ev =>
        moment(ev.start).isSame(moment(event.start)) &&
        moment(ev.end).isSame(moment(event.end)) &&
        (ev.startTime || '') === (event.startTime || '') &&
        (ev.endTime || '') === (event.endTime || '') &&
        (ev.title || '') === (event.title || '')
      )
    );

    return uniqueMerged;
  }

  const fetchAvailability = async () => {
    if (startDate && selectedProvider) {
      const { data } = await getProviderAvailability({ id: selectedProvider.id, indexDate: startDate, market_id: selectedProvider?.market_id }).unwrap();
      // const leaves = await fetchProviderLeaves(selectedProvider.id)
      const monthlyAvailabilities = data?.availability_json ? JSON.parse(data?.availability_json) : [];
      const { day_preferences, working_days } = data?.weekly_availability || {};
      const { leaves } = data;

      const monthlyAvailability = transformedMonthlyAvailability(monthlyAvailabilities);
      const weeklySettings = transformedWeeklySettings(day_preferences, working_days, startDate);
      const providerLeaves = transformedLeaves(leaves || []);

      const availability = generateMergedEvents(monthlyAvailability, weeklySettings, providerLeaves, leaves);
      setAvailability(availability);
    }
  }

  useEffect(() => {
    const newWeeks = getDatesInMonth(1, 2024);
    newWeeks.pop();
    setWeeks(newWeeks);
  }, []);

  useEffect(() => {
    if (
      user.organisation?.coOrdinates?.latitude !== undefined &&
      user.organisation?.coOrdinates?.latitude !== null &&
      !selectedProvider
    ) {
      setZone({
        ...zone,
        coords: {
          lat: user.organisation?.coOrdinates?.latitude,
          lng: user.organisation?.coOrdinates?.longitude,
          zoom: 9,
        },
      });
    } else if (
      user.details?.coOrdinates?.latitude !== undefined &&
      user.details?.coOrdinates?.latitude !== null &&
      user.type === 3
    ) {
      // setZone({
      //   ...zone,
      //   coords: {
      //     lat: user.details?.coordinates?.latitude,
      //     lng: user.details?.coordinates?.longitude,
      //     zoom: 9,
      //   },
      // });
    }

    try {
      const providerTimezone = tzlookup(
        selectedProvider?.coords?.lat,
        selectedProvider?.coords?.lng
      );
      setProviderTimezone(providerTimezone);
    } catch (error) {
      setProviderTimezone(estTimezone);
    }
  }, [selectedProvider]);

  useEffect(() => {
    if (selectedProvider && selectedDate && availability?.length) {
      const currentDayAvailabilities = availability.filter(({ start }) => moment(start).format('YYYY-MM-DD') === moment(selectedDate).format('YYYY-MM-DD'));
      if (currentDayAvailabilities?.length) {
        currentDayAvailabilities.sort((a, b) => moment(a.start).diff(moment(b.start)));
        const partialAvail = currentDayAvailabilities?.filter((e) => e?.type == 'partial');
        if (partialAvail?.length) {
          setCurrentDayAvailability(partialAvail);
        } else {
          const availability = currentDayAvailabilities?.filter((e) => !e?.isLeave);
          if (availability?.length) {
            setCurrentDayAvailability(availability);
          } else {
            setCurrentDayAvailability(currentDayAvailabilities);
          }
        }
      } else {
        setCurrentDayAvailability([]);
      }
    }
  }, [selectedProvider, selectedDate, availability])

  const onPublishClick = () => setIsPublish(true);

  useEffectSkipFirst(() => {
    if (selectedZone) {
      setSelectedProvider(null);
      if (!selectedProvider) fetchAppointmentsConsolidated();
      if (selectedProvider) fetchAppointmentsFunction();
    }
  }, [selectedZone]);

  useEffect(() => {
    if (!selectedProvider) fetchAppointmentsConsolidated();
    if (selectedProvider) fetchAppointmentsFunction();
  }, [selectedDate]);

  useEffect(() => {
    if (selectedProvider) fetchAppointmentsFunction();
  }, [selectedProvider]);

  useEffect(() => {
    fetchAppointmentCount();
    setRecallSchedule(false);

    fetchAvailability()
  }, [startDate, selectedProvider]);

  useEffect(() => {
    if (
      consolidatedAppointments?.length > 0 &&
      providerSelected &&
      Number(providerSelected) !== selectedProvider?.id &&
      providers?.length > 0
    ) {
      const provider = providers.find((provider) =>
        [...(provider?.providers || []).map((p) => p.id)].includes(
          Number(providerSelected)
        )
      );
      setSelectedProvider({
        ...consolidatedAppointments.find(
          (appointment) => appointment.provider.id === Number(providerSelected)
        )?.provider,
        ...provider,
      });
    }
  }, [providerSelected, consolidatedAppointments, providers]);

  useEffect(() => {
    if (dateSelected) {
      setSelectedDate(dateSelected);
    }
  }, [dateSelected]);

  useEffect(() => {
    if (!appointmentSelectedParam) return;

    const dateKey = moment(selectedDate).format("YYYY-MM-DD");
    const appointmentsForDay = appointments?.[dateKey];
    if (!appointmentsForDay?.length) return;

    if (
      selectedAppointment?.appointmentId &&
      `${selectedAppointment.appointmentId}` === `${appointmentSelectedParam}`
    ) {
      return;
    }

    const match = appointmentsForDay.find(
      (appt) => `${appt.appointmentId}` === `${appointmentSelectedParam}`
    );

    if (match) {
      setSelectedAppointment(match);
    }
  }, [
    appointmentSelectedParam,
    appointments,
    selectedDate,
    selectedAppointment,
    setSelectedAppointment,
  ]);

  const handleCancel = async ({ reason, description, reasonId }) => {
    try {
      const payload = {
        activity: `Schedule (${appointmentToCancel.appointmentId}) on ${moment(
          selectedDate
        ).format("MMMM DD, YYYY")} Cancelled for Provider ${selectedProvider.name
          } and Patient ${appointmentToCancel.patient.name} by User - ${user?.details?.name || ""
          } with Reason ${reason}`,
        type: ACTIVITY_TYPE.APPOINTMENT_CANCELED,
        data: {
          providerId: selectedProvider?.id,
          patientId: appointmentToCancel?.patient?.id,
        },
      };
      try {
        await cancelAppointment({
          appointmentId: appointmentToCancel.appointmentId,
          reason,
          description,
          practiceId: user?.organisation?.practiceId,
          patientId: appointmentToCancel?.patient?.idInEhr,
          publishedId: appointmentToCancel.publishedId,
          patientname: appointmentToCancel?.patient?.name,
          reasonId,
        }).unwrap();
        await createLog({
          ...payload,
          status: ACTIVITY_STATUS.SUCCESS,
        }).unwrap();

        console.log(
          `Appointment ${appointmentToCancel.appointmentId} cancelled`
        );

        setRecallSchedule(true);
      } catch (error) {
        console.log(error);
        await createLog({
          ...payload,
          status: ACTIVITY_STATUS.FAILED,
        }).unwrap();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleLock = async () => {
    try {
      const isLocked = appointmentToLock.status === "LOCKED";
      const payload = {
        activity: `Schedule (${appointmentToLock.appointmentId}) on ${moment(
          selectedDate
        ).format("MMMM DD, YYYY")} ${isLocked ? "unlocked" : "locked"
          } for Provider ${selectedProvider.name} and Patient ${appointmentToLock.patient.name
          } by User - ${user?.details?.name || ""}`,
        type: isLocked
          ? ACTIVITY_TYPE.VISIT_UNLOCKED
          : ACTIVITY_TYPE.VISIT_LOCKED,
        data: {
          providerId: appointmentToLock?.providerId,
          patientId: appointmentToLock?.patient?.id,
        },
      };
      try {
        await lockAppointment({
          appointmentId: appointmentToLock.appointmentId,
        }).unwrap();
        await createLog({
          ...payload,
          status: ACTIVITY_STATUS.SUCCESS,
        }).unwrap();

        console.log(`Appointment ${appointmentToLock.appointmentId} locked`);

        setRecallSchedule(true);
      } catch (error) {
        console.log(error);
        await createLog({
          ...payload,
          status: ACTIVITY_STATUS.FAILED,
        }).unwrap();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangeStatus = async (status) => {
    try {
      const payload = {
        activity: `Schedule (${appointmentToChangeStatus.appointmentId
          }) on ${moment(selectedDate).format(
            "MMMM DD, YYYY"
          )} changed status to ${status} for Provider ${selectedProvider.name
          } and Patient ${appointmentToChangeStatus.patient.name} by User - ${user?.details?.name || ""
          }`,
        type: ACTIVITY_TYPE.VISIT_STATUS_CHANGE,
        data: {
          providerId: appointmentToChangeStatus?.providerId,
          patientId: appointmentToChangeStatus?.patient?.id,
        },
      };

      try {
        await updateAppointmentStatus({
          appointmentId: appointmentToChangeStatus.appointmentId,
          status,
        }).unwrap();

        await createLog({
          ...payload,
          status: ACTIVITY_STATUS.SUCCESS,
        }).unwrap();

        console.log(
          `Appointment ${appointmentToChangeStatus.appointmentId} status changed to ${status}`
        );

        setRecallSchedule(true);
      } catch (error) {
        console.log(error);
        await createLog({
          ...payload,
          status: ACTIVITY_STATUS.FAILED,
        }).unwrap();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangeSlot = async (timeslot) => {
    try {
      const payload = {
        activity: `Schedule (${appointmentToChangeTimeslot.appointmentId
          }) on ${moment(selectedDate).format(
            "MMMM DD, YYYY"
          )} changed timeslot to ${timeslot} for Provider ${selectedProvider.name
          } and Patient ${appointmentToChangeTimeslot.patient.name} by User - ${user?.details?.name || ""
          }`,
        type: ACTIVITY_TYPE.VISIT_STATUS_CHANGE,
        data: {
          providerId: appointmentToChangeTimeslot?.providerId,
          patientId: appointmentToChangeTimeslot?.patient?.id,
        },
      };
      try {
        await updateAppointmentTimeslot({
          appointmentId: appointmentToChangeTimeslot.appointmentId,
          timeslot,
          patientId: appointmentToChangeTimeslot.patient.id,
          date: appointmentToChangeTimeslot.visitDate,
          providerId: appointmentToChangeTimeslot.provider.id,
        }).unwrap();
        await createLog({
          ...payload,
          status: ACTIVITY_STATUS.SUCCESS,
        }).unwrap();

        console.log(
          `Appointment ${appointmentToChangeTimeslot.appointmentId} timeslot changed to ${timeslot}`
        );

        setRecallSchedule(true);
      } catch (error) {
        console.log(error);
        await createLog({
          ...payload,
          status: ACTIVITY_STATUS.FAILED,
        }).unwrap();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleEditSave = async (e, override = false, appts) => {
    try {
      if (!override) {
        setEditable(!editable);
        if (!editable) return null;
      }
      const changedAppts = appts
        ? appts[moment(selectedDate).format("YYYY-MM-DD")].filter(
          (appt) =>
            appt.changedTimeslot ||
            appt.changedDepartment ||
            appt.changedVisitType
        )
        : appointments[moment(selectedDate).format("YYYY-MM-DD")].filter(
          (appt) =>
            appt.changedTimeslot ||
            appt.changedDepartment ||
            appt.changedVisitType
        );
      if (changedAppts.length === 0) return null;

      const payload = changedAppts.map((appt) => {
        return {
          activity: `Schedule (${appt.appointmentId}) on ${moment(
            selectedDate
          ).format("MMMM DD, YYYY")} changed timeslot to ${appt.timeslot
            } from ${appt.oldTimeslot} for Provider ${selectedProvider.name
            } and Patient ${appt.patient.name} by User - ${user?.details?.name || ""
            }`,
          type: ACTIVITY_TYPE.VISIT_STATUS_CHANGE,
          data: {
            providerId: appt.providerId,
            patientId: appt.patient?.id,
          },
        };
      });
      try {
        const appointmentsPayload = changedAppts.map((appt) => ({
          id: appt.appointmentId,
          timeslot: moment(appt.timeslot, "HH:mm A").format("HH:mm"),
          departmentId: appt.departmentId,
          appointmentType: Number(appt.appointmentType?.id),
          isTimeslotChanged: appt.changedTimeslot,
          isAppointmentTypeChanged: appt.changedAppointmentType,
          isDepartmentChanged: appt.changedDepartment,
        }));
        try {
          const body = {
            appointments: appointmentsPayload,
            date: changedAppts?.[0]?.visitDate,
            providerId: changedAppts?.[0]?.provider.id,
            practiceId: user?.organisation?.practiceId,
            override,
          };
          await updateBulkAppointmentTimeslot(body).unwrap();
          setRecallSchedule(true);
        } catch (error) {
          const message = error?.data?.message;
          if (message) {
            if (message?.startsWith("!")) {
              setSecondaryTitle(null);
              setPrimaryTitle("Okay");
              setError(message?.slice(1));
            } else {
              setSecondaryTitle("No");
              setPrimaryTitle("Yes");
              setError(message);
            }
          }
        }
        await Promise.all(
          payload.map(async (appt) => {
            return await createLog({
              ...appt,
              status: ACTIVITY_STATUS.SUCCESS,
            }).unwrap();
          })
        );
      } catch (error) {
        console.log(error);
        setRecallSchedule(true);
        setShowError([
          {
            id: 1,
            error: error?.data?.message || "Something went wrong!",
          },
        ]);
        await Promise.all(
          payload.map(
            async (appt) =>
              await createLog({
                ...appt,
                status: ACTIVITY_STATUS.FAILED,
              }).unwrap()
          )
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleEditCancel = () => {
    setEditable(false);
    setRecallSchedule(true);
  };

  useEffect(() => {
    if (recallSchedule) {
      // setAppointments([]);
      fetchAppointmentsFunction();
      fetchAppointmentCount();
      setRecallSchedule(false);
    }
  }, [recallSchedule]);

  const handleCancelModal = () => {
    if (openCancelModal) setAppointmentToCancel(null);
    setOpenCancelModal(!openCancelModal);
  };

  const handleLockModal = () => {
    if (openLockModal) setAppointmentToLock(null);
    setOpenLockModal(!openLockModal);
  };

  const handleSequenceModal = () => {
    setDraggingAppointment(null);
    setTargetIndex(null);
  };

  const handleStatusModal = (status) => {
    if (openStatusModal) setAppointmentToChangeStatus(null);
    setOpenStatusModal(!openStatusModal);
  };

  const handleSlotModal = (data) => {
    if (appointmentToChangeTimeslot) {
      setAppointmentToChangeTimeslot(null);
    } else {
      setAppointmentToChangeTimeslot(data);
    }
  };

  const handleBulkSchedule = ({
    date = null,
    providerId = null,
    count = null,
    appointments = null,
  }) => {
    setOpenBulkSchedule(!openBulkSchedule);
    if (date != null && providerId != null)
      setDataToBulkSchedule({ date, providerId, count, appointments });
    else setDataToBulkSchedule(null);
  };

  const handleDrop = async (appt, idx) => {
    const appointment = appt ?? draggingAppointment;
    const index = idx ?? targetIndex;
    const payload = {
      activity: `Schedule (${appointment.appointmentId}) on ${moment(
        appointment.visitDate
      ).format("MMMM DD, YYYY")} sequence changed from ${appointment.sequenceNo
        } to ${index + 1} for Provider ${selectedProvider.name} and Patient ${appointment.patient?.name
        } by User - ${user?.details?.name || ""}`,
      type: ACTIVITY_TYPE.SEQUENCE_CHANGE,
      data: {
        providerId: appointment?.providerId,
        patientId: appointment?.patient?.id,
      },
    };

    try {
      if (
        appointment === null &&
        index !== appointments?.[appointment.visitDate].length
      )
        return;

      // const notMovable =
      //   appointments?.[appointment.visitDate]?.[index]?.status !== "UNLOCKED";
      // if (
      //   notMovable &&
      //   index !== appointments?.[appointment.visitDate].length
      // ) {
      //   return console.log("Cannot move to locked appointment", index);
      // }

      const { data } = await rescheduleAppointments({
        dayToBeMoved: appointment.visitDate,
        indexToBeMoved: index + 1,
        appointmentId: appointment.appointmentId,
        practiceId: user?.organisation?.practiceId,
      }).unwrap();

      await createLog({ ...payload, status: ACTIVITY_STATUS.SUCCESS }).unwrap();

      const { appointmentsTo } = data;

      const newAppointments = {
        ...appointments,
        [appointment.visitDate]: appointmentsTo,
      };

      setDraggingAppointment(null);
      setTargetIndex(null);
      setRecallSchedule(true);

      if (document.startViewTransition) {
        document.startViewTransition(() => {
          flushSync(() => {
            setAppointments(newAppointments);
          });
        });
      } else {
        setAppointments(newAppointments);
      }
    } catch (error) {
      // console.error(error);
      await createLog({ ...payload, status: ACTIVITY_STATUS.FAILED }).unwrap();
      setShowError(error?.data?.errors);
    }
  };

  const onDrop = (index, appt) => {
    setTargetIndex(index);
    // appt && setDraggingAppointment(appt);
    handleDrop(appt, index);
  };

  const handleProviderList = () => {
    setShowProviderList(!showProviderList);
  };

  const fetchFilterOptions = async () => {
    try {
      if (selectedProvider != null) {
        console.log("selectedProvider", selectedProvider);

        const { data } = await filterAppointmentOptions({
          providerId: selectedProvider.id,
          date: moment(selectedDate).format("YYYY-MM-DD"),
          marketId: selectedProvider?.market_id
        });

        setFilterOptions(data.data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const fetchZones = async () => {
    try {
      const { data } = await getZones().unwrap();
      setZones(
        data?.map((zone) => {
          return {
            ...zone,
            zipCodes: zone.zip_codes,
          };
        })
      );
    } catch (error) {
      console.error(error.data.message);
    }
  };

  useEffect(() => {
    fetchZones();
  }, []);

  useEffect(() => {
    if (selectedProvider) fetchFilterOptions();
  }, [selectedProvider]);

  const isProvider = !!selectedProvider?.id;

  const Mileage = isProvider
    ? appointments[moment(selectedDate).format("YYYY-MM-DD")]?.reduce(
      (total, current, idx) => {
        if (
          idx === 0 ||
          idx ===
          appointments[moment(selectedDate).format("YYYY-MM-DD")].length - 1
        ) {
          return total + Number(current.distanceFromHome);
        }
        return total + Number(current.distance);
      },
      0
    )
    : 0;

  const providerFilter = (appointment) => {
    if (searchText === "") return true;
    return appointment.provider.name
      .toLowerCase()
      .includes(searchText.toLowerCase());
  };

  const appointmentFilter = (appointment) => {
    if (searchText === "") return true;
    return (
      (appointment.patient?.name || "")
        ?.toLowerCase()
        ?.includes(searchText.toLowerCase()) ||
      (appointment.location?.name || "")
        ?.toLowerCase()
        ?.includes(searchText.toLowerCase())
    );
  };

  const [dragPosition, setDragPosition] = React.useState({ x: 0, y: 0 });

  const containerRef = React.useRef(null);

  const handleDrag = (event) => {
    const { clientX, clientY } = event;
    const container = containerRef.current;

    if (container) {
      const { top, left, bottom, right } = container.getBoundingClientRect();
      const scrollSpeed = 10;

      // Check if the drag is near the container's edges and scroll accordingly
      if (clientX > right - 50)
        container.scrollBy({ left: scrollSpeed, behavior: "smooth" });
      if (clientX < left + 50)
        container.scrollBy({ left: -scrollSpeed, behavior: "smooth" });
      if (clientY > bottom - 50)
        container.scrollBy({ top: scrollSpeed, behavior: "smooth" });
      if (clientY < top + 50)
        container.scrollBy({ top: -scrollSpeed, behavior: "smooth" });

      // Update drag position for custom logic if needed
      setDragPosition({ x: clientX, y: clientY });
    }
  };
  const filteredAppointments = selectedProvider
    ? appointments[moment(selectedDate).format("YYYY-MM-DD")]?.filter(
      appointmentFilter
    )
    : [];

  useEffect(() => {
    const timeslotsFunc = async () => {
      const timeslotsList =
        (await getSlotsAvailable([], {
          startTime: "06:00",
          endTime: "23:45",
        })) ?? [];
      setTimeslots(timeslotsList);
    };
    timeslotsFunc();
  }, []);

  useEffect(() => {
    if (user.type === 3) {
      const markets = user.details?.market || [];
      // Get primary market, or first market if no primary
      const primaryMarket = markets.find(m => m.is_primary_market) || markets[0];
      
      setSelectedProvider({
        id: user.details.provider_id,
        name: user.details.name,
        speciality: user.details.speciality,
        market_id: primaryMarket?.id,
        market_name: primaryMarket?.market_name,
        coordinates: {
          latitude: user.details.coordinates?.latitude,
          longitude: user.details.coordinates?.longitude,
        },
      });
    }
  }, [user]);

  const handleTimeslot = (id, timeslot, doubleBook = false, isSave) => {
    const appointmentsList =
      appointments[moment(selectedDate).format("YYYY-MM-DD")];
    const appointment = appointmentsList?.map((appt) => {
      if (appt.appointmentId === id) {
        return {
          ...appt,
          oldTimeslot: appt.timeslot,
          changedTimeslot: !moment(appt.timeslot, "hh:mm A z").isSame(
            moment(timeslot, "HH:mm"),
            "minute"
          ),
          timeslot,
        };
      }
      if (appt.timeslot === timeslot && !doubleBook) {
        return {
          ...appt,
          oldTimeslot: appt.timeslot,
          changedTimeslot: true,
          timeslot: moment(
            appointmentsList[appointmentsList.length - 1]?.timeslot || timeslot
          )
            .add(30, "minutes")
            .format("hh:mm A"),
        };
      }
      return appt;
    });
    let appts = {
      ...appointments,
      [moment(selectedDate).format("YYYY-MM-DD")]: appointment,
    };
    setAppointments(appts);

    isSave ? handleEditSave(null, doubleBook, appts) : "";
    if (doubleBook) {
      setEditable(!editable);
    }
  };

  const handleDepartment = async (id, departmentId) => {
    try {
      await updateAppointment({
        id,
        departmentId: Number(departmentId),
        practiceId: user?.organisation?.practiceId,
      }).unwrap();
      // setRecallSchedule(true);
      const appointmentsList =
        appointments[moment(selectedDate).format("YYYY-MM-DD")];
      const appointment = appointmentsList?.map((appt) => {
        if (appt.appointmentId === id) {
          return {
            ...appt,
            departmentId,
            // changedDepartment: true,
          };
        }
        return appt;
      });
      setAppointments({
        ...appointments,
        [moment(selectedDate).format("YYYY-MM-DD")]: appointment,
      });
      setEditable(false);
    } catch (error) {
      console.error(error);
      setShowError([{
        id: 1,
        error: error?.data?.message ?? error?.message,
      }]);
      // setRecallSchedule(true);
    }
  };

  const handleVisitType = async (id, visitType, isSave) => {
    if (isSave) {
      try {
        await updateAppointment({
          id,
          appointmentType: Number(visitType),
          practiceId: user?.organisation?.practiceId,
        }).unwrap();
        // setRecallSchedule(true);
        const appointmentsList =
          appointments[moment(selectedDate).format("YYYY-MM-DD")];
        const appointment = appointmentsList?.map((appt) => {
          if (appt.appointmentId === id) {
            const apptType = appointmentTypes.find((type) => type.id === Number(visitType));
            console.log(apptType, 'apptType');
            return {
              ...appt,
              oldAppointmentType: appt.appointmentType,
              isTelehealth: apptType?.is_telehealth,
              appointmentType: {
                id: visitType,
                name: apptType?.name,
                isTelehealth: apptType?.is_telehealth,
                duration: apptType?.duration,
              },
              // changedVisitType: true,
            };
          }
          return appt;
        });
        const appts = {
          ...appointments,
          [moment(selectedDate).format("YYYY-MM-DD")]: appointment,
        }
        console.log(appts, 'appts');
        setAppointments(appts);
        setEditable(false);
      } catch (error) {
        console.error(error);
        setShowError([{
          id: 1,
          error: error?.data?.message ?? error?.message,
        }]);
        // setRecallSchedule(true);
      }
    }
  };

  const getVisitStatusText = (status) => {
    switch (status) {
      case "SCHEDULED":
        return (
          <div className="flex gap-1 items-center">
            <Icon name="20-hourglass" color={"#F2C94C"} />
            <span>Pending</span>
          </div>
        );
      case "NOSHOW":
        return (
          <div className="flex gap-1 items-center">
            <Icon name="20-user-minus" color={"#F59638"} />
            <span>No Show</span>
          </div>
        );
      case "CONFIRMED":
        return (
          <div className="flex gap-1 items-center">
            <Icon name="20-calendar-check" color={"#3062D4"} />
            <span>Confirmed</span>
          </div>
        );
      case "CANCELLED":
        return (
          <div className="flex gap-1 items-center">
            <Icon name="20-calendar-close" color={"#eb5757"} />
            <span>Cancelled</span>
          </div>
        );
      default:
        return (
          <div className="flex gap-1 items-center">
            <CheckSvg color={"#27AE60"} />
            <span>Completed</span>
          </div>
        );
    }
  };

  const getLockStatusText = (status) => {
    switch (status) {
      case "PUBLISHED":
        return (
          <div className="flex gap-1 items-center">
            <CheckSvg color={"#27AE60"} />
            <span>Published</span>
          </div>
        );
      case "UNLOCKED":
        return (
          <div className="flex gap-1 items-center">
            <Unlock color={"#F2C94C"} />
            <span>Unlocked</span>
          </div>
        );
      default:
        return (
          <div className="flex gap-1 items-center">
            <Lock color={"#3062D4"} />
            <span>Locked</span>
          </div>
        );
    }
  };

  const [providerSearch, setProviderSearch] = React.useState("");

  return (
    <div className="relative flex flex-col md:flex-row h-[calc(100vh-70px)] overflow-auto divide-x-[1px]">
      <Loading loading={isLoading} />
      <div
        className={classNames(
          "flex flex-col w-full gap-3 p-6 pb-3 overflow-auto md:w-1/2",
          selectedAppointment || addOpen ? "opacity-40" : "opacity-100"
        )}
      >
        <div>
          <h2 className="flex items-center m-0 text-4xl font-semibold">
            {/* Command Center {" | "} */}
            Command Center
            {/* {user.type === 1 ? " | " : ""} */}
            {/* {user.type === 1 && ( */}
            {/* {user?.permissions?.includes('cc_home.view_cc_zones') && <>
              <button
                id="zone-button"
                aria-controls={open ? "zone-menu" : undefined}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={handleZoneClick}
                className="btn text-capitalize"
              >
                <span className="text-4xl font-semibold zone text-primaryblue">
                  {selectedZone?.name}
                </span>
              </button>
              <Menu
                id="basic-menu"
                anchorEl={zoneAnchor}
                open={zoneOpen}
                onClose={handleZoneClose}
                MenuListProps={{
                  "aria-labelledby": "basic-button",
                }}
              >
                <MenuItem
                  onClick={() =>
                    handleSelect({
                      id: 0,
                      name: "All Zones",
                      coords: {
                        lat: user.organisation?.coOrdinates?.latitude,
                        lng: user.organisation?.coOrdinates?.longitude,
                        zoom: 9,
                      },
                    })
                  }
                >
                  All Zones
                </MenuItem>
                {zones?.map((zone, i) => {
                  return (
                    <MenuItem key={i} onClick={() => handleSelect(zone)}>
                      {zone?.name}
                    </MenuItem>
                  );
                })}
              </Menu>
            </>} */}
            {/* )} */}
          </h2>
          <span className="px-1 command-time">
            {moment().format("MMMM D, YYYY, hh:mm A z")}
          </span>
        </div>

        <Tabs
          tabs={[user?.permissions?.includes('cc_home.view_cc_map') && "Map", user?.permissions?.includes('cc_home.view_cc_calendar') && "Calendar"].filter(Boolean)}
          components={[
            (user?.permissions?.includes('cc_home.view_cc_map') && <Map
              isProvider={!!selectedProvider?.id}
              data={!!selectedProvider?.id ? providerData : providers}
              selectedProvider={
                !!selectedProvider?.id ? selectedProvider : undefined
              }
            />),
            (user?.permissions?.includes('cc_home.view_cc_calendar') && <Calendar
              className={"h-[500px]"}
              onClickMonth={onMonthChange}
              onActiveStartDateChange={onMonthChange}
              value={selectedDate}
              onChange={onDateChange}
              tileContent={({ date, view }) => {
                return (
                  <>
                    {count.find(
                      (x) => x.date === moment(date).format("YYYY-MM-DD")
                    ) === undefined ? (
                      <></>
                    ) : (
                      <div
                        className={classNames(
                          "flex items-center justify-center w-5 h-5 mx-auto mt-2 text-[10px] rounded-full",
                          moment(selectedDate).format("YYYY-MM-DD") !==
                            moment(date).format("YYYY-MM-DD")
                            ? "bg-primaryblue text-white"
                            : "bg-white text-primaryblue"
                        )}
                      >
                        {
                          count.find(
                            (x) => x.date === moment(date).format("YYYY-MM-DD")
                          )?.noOfAppointments
                        }
                      </div>
                    )}
                  </>
                );
              }}
            />),
          ].filter(Boolean)}
        />
      </div>
      <div
        className={classNames(
          "flex flex-col w-full gap-3 p-6 pb-3 overflow-auto md:w-1/2",
          selectedAppointment || addOpen ? "opacity-40" : "opacity-100"
        )}
      >
        <div className="flex flex-col gap-3 md:flex-row">
          <SelectableButton
            onClick={() => setSelectedTab("Scheduler")}
            title={"Scheduler"}
            isSelected={selectedTab === "Scheduler"}
            className={"py-2"}
          />
          <SelectableButton
            onClick={() => setSelectedTab("Messenger")}
            title={"Messenger"}
            isSelected={selectedTab === "Messenger"}
            className={"py-2"}
            disabled={!user?.permissions?.includes('cc_home.view_cc_messenger')}
          />
        </div>
        {selectedTab === "Scheduler" && user?.permissions?.includes('cc_home.provider_search') && (
          <>
            <div className="flex flex-col gap-3 md:flex-row">
              <button
                // disabled={user.type === 3 && user.details?.market?.length === 1}
                onClick={handleProviderList}
                className="flex relative items-center justify-center w-full h-10 gap-2 py-2 text-white rounded-md border-[1px] border-primaryblue bg-primaryblue disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {selectedProvider ? (
                  <UserSvg color={"#FFF"} />
                ) : (
                  <UsersSvg color={"#FFF"} />
                )}
                {/* {user.type === 3 ? (
                  <p className="m-0 text-xl">{user.details.name}</p>
                ) : ( */}
                <p className="m-0 text-xl">
                  {
                    selectedProvider 
                      ? selectedProvider.name 
                      : "All Providers"}
                </p>
                {/* )} */}
                {user.type !== 3 ? (
                  <div className={classNames("")}>
                    <Dropdown color={"#FFF"} />
                  </div>
                ) : user.details?.market?.length >= 1 && (
                  <div className={classNames("")}>
                    <Dropdown color={"#FFF"} />
                  </div>
                )}
                <div
                  className={classNames(
                    "absolute w-full max-h-60 bg-white border-[1px] rounded-md overflow-y-auto flex-col text-black z-[999] top-[120%]",
                    !showProviderList ? "hidden" : "flex"
                  )}
                  onMouseDown={(e) => e.stopPropagation()}
                  onClick={(e) => e.stopPropagation()}
                >
                  <input
                    type="text"
                    value={providerSearch}
                    onChange={(e) => setProviderSearch(e.target.value)}
                    placeholder="Search providers..."
                    className="p-2 w-full border-b outline-none"
                    style={{ minWidth: 0 }}
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={(e) => e.stopPropagation()}
                  />
                  {user.type === 7 ? (
                    // For provider users, show msarkets
                    (() => {
                      const markets = user.details?.market || [];
                      const marketsToShow = markets.length > 1 
                        ? markets 
                        : markets.filter(m => m.is_primary_market);
                      
                      return marketsToShow
                        .filter((market) =>
                          market.market_name
                            ?.toLowerCase()
                            .includes(providerSearch.toLowerCase())
                        )
                        .sort((a, b) => {
                          // Primary market first
                          if (a.is_primary_market && !b.is_primary_market) return -1;
                          if (!a.is_primary_market && b.is_primary_market) return 1;
                          return a.market_name.localeCompare(b.market_name);
                        })
                        .map((market, index, arr) => (
                          <button
                            key={market.id}
                            onClick={() => {
                              setSelectedProvider({
                                id: user.details.provider_id,
                                name: user.details.name,
                                speciality: user.details.speciality,
                                market_id: market.id,
                                market_name: market.market_name,
                                coordinates: {
                                  latitude: user.details.coordinates?.latitude,
                                  longitude: user.details.coordinates?.longitude,
                                },
                              });
                              handleProviderList();
                            }}
                            className={classNames(
                              "flex flex-row items-center hover:bg-primarylightgrey gap-2 p-2",
                              index === arr.length - 1
                                ? "border-none"
                                : "border-b-[1px]"
                            )}
                          >
                            <div className="flex justify-center items-center w-8 h-8 rounded-full bg-primarygrayborder">
                              <p className="m-0 font-semibold text-white">
                                {avatarName(user.details.name)}
                              </p>
                            </div>
                            <p className="m-0">
                              {user.details.name} ({market.market_name})
                              {market.is_primary_market && " (Primary)"}
                            </p>
                          </button>
                        ));
                    })()
                  ) : (
                    // For non-provider users, show all providers
                    <>
                      <button
                        onClick={() => {
                          setSelectedProvider(null);
                          handleProviderList();
                        }}
                        className={classNames(
                          "flex flex-row gap-2 items-center p-2 hover:bg-primarylightgrey",
                          "border-b-[1px]"
                        )}
                      >
                        All Providers
                      </button>
                      {consolidatedAppointments
                        .filter((appointments) =>
                          appointments.provider.name
                            .toLowerCase()
                            .includes(providerSearch.toLowerCase())
                        )
                        .sort((a, b) =>
                          a.provider.name.localeCompare(b.provider.name)
                        )
                        .map((appointments, index, arr) => (
                          <button
                            key={appointments.id}
                            onClick={() => {
                              const provider = providers.find((provider) =>
                                [
                                  ...(provider?.providers || []).map((p) => p.id),
                                ].includes(Number(appointments.provider.id))
                              );
                              setSelectedProvider({
                                ...appointments.provider,
                                ...provider,
                              });
                              navigate(
                                `/home?providerId=${appointments.provider?.id}`
                              );
                              handleProviderList();
                            }}
                            className={classNames(
                              "flex flex-row items-center hover:bg-primarylightgrey gap-2 p-2",
                              index === arr.length - 1
                                ? "border-none"
                                : "border-b-[1px]"
                            )}
                          >
                            <div className="flex justify-center items-center w-8 h-8 rounded-full bg-primarygrayborder">
                              <p className="m-0 font-semibold text-white">
                                {avatarName(appointments.provider.name)}
                              </p>
                            </div>
                            <p className="m-0">{appointments.provider.name}</p>
                          </button>
                        ))}
                    </>
                  )}
                </div>
              </button>
              {user?.permissions?.includes('cc_home.cc_download_schedules') && (
                <Tooltip title="Download schedules">
                  <button
                    className="flex items-center justify-center w-10 h-10 bg-white border-[1px] rounded-md border-primaryblue disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 ease-in-out"
                    onClick={downloadCSV}
                    disabled={!selectedProvider || selectedAppointment}
                  >
                    <Download color={"#3062D4"} />
                  </button>
                </Tooltip>
              )}
            </div>
            <div className="flex flex-col gap-2">
              <div className="flex flex-col gap-2">
                <div className="flex flex-row justify-between">
                  <div className="flex flex-row gap-4">
                    {selectedProvider !== null && (
                      <Tooltip title="Back to providers">
                        <button
                          disabled={selectedProvider === null}
                          onClick={() => {
                            setSelectedProvider(null);
                            setEditable(false);
                            setSearchText("");
                            setSearchParams({});
                          }}
                          className={classNames(
                            "flex justify-center items-center w-10 h-10 rounded-md transition-all duration-200 ease-in-out bg-primarylightgrey disabled:opacity-50 disabled:cursor-not-allowed"
                          )}
                        >
                          <div className="rotate-90">
                            <Dropdown color={"#000"} />
                          </div>
                        </button>
                      </Tooltip>
                    )}
                    <p className="m-0 text-3xl">
                      {moment(selectedDate).format("YYYY-MM-DD") ===
                        moment().format("YYYY-MM-DD")
                        ? "Today"
                        : moment(selectedDate).format("MMMM DD, YYYY")}
                    </p>
                  </div>
                  <div className="flex flex-row gap-4">
                    {selectedProvider !== null && user?.permissions?.includes('cc_home.optimize_route') && (
                      <Tooltip title="Optimize Route" arrow>
                        <button
                          disabled={filteredAppointments?.length === 0}
                          className={classNames(
                            filteredAppointments?.length === 0 && " opacity-40"
                          )}
                          onClick={() => {
                            if (filteredAppointments?.length === 0) return;
                            handleOptimise(
                              filteredAppointments[0]?.visitDate,
                              filteredAppointments[0]?.provider.id
                            );
                          }}
                        >
                          <div className="flex justify-center items-center w-10 h-10 rounded-md bg-primarylightgrey">
                            <BsLightningChargeFill size={20} color="#fdb53f" />
                          </div>
                        </button>
                      </Tooltip>
                    )}
                    {selectedProvider !== null && user?.permissions?.includes('cc_home.bulk_actions') && (
                      <Tooltip title="Bulk scheduling actions" arrow>
                        <button
                          disabled={filteredAppointments?.length === 0}
                          className={classNames(
                            filteredAppointments?.length === 0 && " opacity-40"
                          )}
                          onClick={() => {
                            if (filteredAppointments?.length === 0) return;
                            handleBulkSchedule({
                              date: moment(selectedDate).format("YYYY-MM-DD"),
                              providerId: filteredAppointments[0]?.provider.id,
                              count: filteredAppointments?.length,
                              appointments: filteredAppointments,
                            });
                          }}
                        >
                          <div className="flex justify-center items-center w-10 h-10 rounded-md bg-primarylightgrey">
                            <Icon name="20-view-schedule" color="#3062D4" />
                          </div>
                        </button>
                      </Tooltip>
                    )}
                    {selectedProvider !== null && user?.permissions?.includes('cc_home.cc_add_appointment') && (
                      <Tooltip title="Add appointment">
                        <button
                          disabled={selectedProvider === null}
                          onClick={() => {
                            setAddOpen(true);
                          }}
                          className={classNames(
                            "flex justify-center items-center w-10 h-10 rounded-md transition-all duration-200 ease-in-out bg-primarylightgrey disabled:opacity-50 disabled:cursor-not-allowed"
                          )}
                        >
                          <div className="rotate-45">
                            <CloseSvg color={"#000"} />
                          </div>
                        </button>
                      </Tooltip>
                    )}
                    {selectedProvider !== null && user?.permissions?.includes('cc_home.cc_schedule_edit') && (
                      <Tooltip
                        title={!editable ? "Edit appointment sequence" : "Save"}
                      >
                        <button
                          disabled={
                            selectedProvider === null
                            // ||
                            // moment(selectedDate).isBefore(moment(), "date")
                          }
                          onClick={() => handleEditSave(null, false, null)}
                          className="flex justify-center items-center w-10 h-10 rounded-md transition-all duration-200 ease-in-out bg-primarylightgrey disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          {!editable ? (
                            <img
                              src={Edit_Icon}
                              alt="edit"
                              className="object-contain w-5 h-5"
                            />
                          ) : (
                            <CheckSvg color={"#0d6efd"} />
                          )}
                        </button>
                      </Tooltip>
                    )}
                    {selectedProvider !== null && editable && (
                      <Tooltip title={"Cancel changes"}>
                        <button
                          onClick={handleEditCancel}
                          className="flex justify-center items-center w-10 h-10 rounded-md transition-all duration-200 ease-in-out bg-primarylightgrey disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                          <CloseSvg color={"#000"} />
                        </button>
                      </Tooltip>
                    )}
                  </div>
                </div>

                <div className="flex flex-row gap-4 justify-stretch">
                  {user?.permissions?.includes('cc_home.search') && <div className="relative flex flex-row w-full items-center gap-2 divide-x-2 rounded-md border-[2px] border-primarylightgrey overflow-clip">
                    <div className="pl-2">
                      <Tooltip title="Search">
                        <img
                          src={Search_Icon}
                          alt="search"
                          className="w-5 h-5 cursor-pointer search-icon"
                        />
                      </Tooltip>
                    </div>
                    <input
                      type="text"
                      placeholder={"Search..."}
                      className="p-2 w-full h-full text-base outline-none"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                    />
                  </div>}
                  {user?.permissions?.includes('cc_home.sort') && <Tooltip title="Sort">
                    <button
                      disabled={selectedProvider !== null}
                      className="flex justify-center items-center self-end h-10 rounded-md transition-all duration-200 ease-in-out min-w-10 bg-primarylightgrey disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      <img
                        src={Sort_Icon}
                        alt="search"
                        className="object-contain w-5 h-5"
                      />
                    </button>
                  </Tooltip>}
                </div>
              </div>
              {isProvider && (
                <div className="flex justify-between">
                  {
                    currentDayAvailability?.length ? (
                      currentDayAvailability[0]?.isLeave
                        ? (
                          <span
                            style={{
                              backgroundColor: "#fca5a5",
                              padding: "4px 5px",
                              borderRadius: "2px",
                              color: "#991b1b",
                              fontSize: "12px",
                              maxWidth: "150px"
                            }}
                            className="ml-2"
                          >
                            Unavailable
                          </span>
                        ) : (
                          currentDayAvailability[0]?.type == 'partial'
                            ? (
                              <span
                                style={{
                                  backgroundColor: "#fff4c7",
                                  padding: "4px 5px",
                                  borderRadius: "2px",
                                  color: "#d8821c",
                                  fontSize: "12px",
                                  maxWidth: "150px"
                                }}
                                className="ml-2"
                              >
                                {currentDayAvailability?.map(e => e?.title?.replace(' to ', ' - '))?.join(', ')}
                              </span>
                            ) : (
                              <span
                                style={{
                                  backgroundColor: "#dbeafe",
                                  padding: "4px 5px",
                                  borderRadius: "2px",
                                  color: "#1e40af",
                                  fontSize: "12px",
                                  maxWidth: "150px"
                                }}
                                className="ml-2"
                              >
                                {currentDayAvailability?.map(e => e?.title?.replace(' to ', ' - '))?.join(', ')}
                              </span>
                            )
                        )
                    ) : <span
                      style={{
                        backgroundColor: "#fca5a5",
                        padding: "4px 5px",
                        borderRadius: "2px",
                        color: "#991b1b",
                        fontSize: "12px",
                        maxWidth: "150px"
                      }}
                      className="ml-2"
                    >
                      Unavailable
                    </span>
                  }

                  <span className="text-xl bold-700 color-o">
                    {" "}
                    Total mileage:{" "}
                    {
                      filteredAppointments?.length
                        ? filteredAppointments
                          .reduce((total, appointment, index) => {
                            return total + (index === 0 ? 0 : +appointment.distance);
                          }, +filteredAppointments[0]?.distanceFromHome + +filteredAppointments[filteredAppointments.length - 1]?.distanceFromHome)
                          .toFixed(2)
                        : "0.00"
                    }{" "}
                    Miles
                  </span>
                </div>
              )}
              {!selectedProvider ? (
                <div className="flex flex-col items-center gap-3 p-2 h-[calc(100vh-310px)] overflow-auto">
                  {consolidatedAppointments
                    ?.filter(providerFilter)
                    .map((appointments) => (
                      <div
                        key={appointments.id}
                        className="flex flex-col w-full gap-4 p-3 rounded-md shadow-custom border-[1px] border-gray-100"
                      >
                        <div className="flex flex-row justify-between items-center">
                          <div className="flex flex-row gap-3 items-center">
                            <div className="flex justify-center items-center w-10 h-10 rounded-full bg-primarygrayborder">
                              <p className="m-0 text-lg font-semibold text-white">
                                {avatarName(appointments.provider.name)}
                              </p>
                            </div>
                            <div>
                              <p className="m-0 text-lg font-semibold">
                                {appointments.provider.name}
                              </p>
                              <p className="m-0 text-sm">
                                {appointments.provider.speciality}
                              </p>
                            </div>
                          </div>
                          <div className="flex flex-col items-start">
                            <p className="m-0 text-sm font-semibold">
                              Distance Travelled
                            </p>
                            <p className="m-0 text-sm">
                              {Math.trunc(
                                Number(appointments.totalDistance)?.toFixed(
                                  0
                                ) ?? 0
                              )}{" "}
                              miles
                            </p>
                          </div>
                        </div>
                        <div className="flex flex-row justify-between items-center">
                          <div className="flex flex-row gap-2 items-center">
                            <p className="m-0 text-xs">
                              {appointments.noOfAppointments} visits
                            </p>
                            <div className="h-6 bg-primarygrayborder w-[1px]" />
                            <p className="m-0 text-sm text-primaryblue">
                              {appointments.noOfCompletedAppointments} visits
                              completed
                            </p>
                          </div>
                          <button
                            onClick={() => {
                              const provider = providers.find((provider) =>
                                [
                                  ...provider.providers.map((p) => p.id),
                                ].includes(appointments.provider.id)
                              );
                              setSelectedProvider({
                                ...appointments.provider,
                                ...provider,
                              });
                              setSearchParams({
                                providerId: appointments.provider.id,
                              });
                              setSearchText("");
                              setZone({
                                ...zone,
                                coords: {
                                  ...zone.coords,
                                  ...(provider?.coords || {}),
                                  zoom: 10,
                                },
                              });
                            }}
                            className="text-xs m-0 py-1 px-2 border-[1px] bg-primaryblue text-white font-semibold rounded-lg"
                          >
                            View schedules
                          </button>
                        </div>
                      </div>
                    ))}
                </div>
              ) : (
                <div
                  ref={containerRef}
                  className={classNames(
                    "flex flex-col gap-2 overflow-auto overflow-x-hidden px-2",
                    user?.organisation?.data?.isEnterprise
                      ? "h-[calc(100vh-410px)]"
                      : "h-[calc(100vh-350px)]"
                  )}
                >
                  <DropArea onDrop={() => onDrop(0)} />
                  {filteredAppointments?.map((appointment, index) => (
                    <>
                      <div className="flex gap-3 items-start w-full">
                        <button
                          draggable={editable}
                          onDrag={handleDrag}
                          onDragStart={() =>
                            setDraggingAppointment(appointment)
                          }
                          // onDragEnd={() => setDraggingAppointment(null)}
                          className={classNames(
                            "flex flex-col w-full gap-4 p-3 bg-white rounded-md shadow-custom border border-primarygrayborder",
                            editable && "cursor-pointer"
                          )}
                          onClick={() => {
                            if (selectedAppointment || addOpen) return;
                            setSelectedAppointment(appointment);
                          }}
                        >
                          <div className="flex relative w-100">
                            <div className="flex flex-col gap-4 w-100">
                              <div className="flex flex-row justify-between w-100">
                                <div className="flex flex-row gap-4 items-center">
                                  <div
                                    className={classNames(
                                      "flex items-center justify-center rounded-full text-white text-sm font-semibold w-10 h-10",
                                      appointment.status === "UNLOCKED"
                                        ? "bg-[#F2C94C]"
                                        : appointment.status === "LOCKED"
                                          ? "bg-[#3062D4]"
                                          : "bg-[#6FCF97]"
                                    )}
                                  >
                                    {index + 1}
                                  </div>
                                  <div className="flex flex-col gap-0 items-start w-6/6">
                                    <span className="w-full text-xl font-bold text-left truncate whitespace-nowrap text-primaryblack">
                                      {appointment.patient.name}
                                      {" | "}
                                      {appointment.location?.name !== null
                                        ? appointment.location?.name
                                        : "Private Residence"}
                                    </span>
                                    <span className="m-0 text-base font-normal text-left text-primarytextgrey">
                                      {index === 0
                                        ? `${Number(
                                          appointment.distanceFromHome
                                        )?.toFixed(0)} miles from home`
                                        : `${Number(
                                          appointment.distance
                                        )?.toFixed(
                                          0
                                        )} miles from previous appointment`}
                                      {index === filteredAppointments.length - 1
                                        ? ` and ${Number(
                                          appointment.distanceFromHome
                                        )?.toFixed(0)} miles from home`
                                        : ``}
                                      {appointment?.appointmentType?.duration &&
                                        ` | ${appointment?.appointmentType?.duration}-min visit`}
                                    </span>
                                    <span className="p-1 mt-2 text-xs font-bold text-blue-600 bg-blue-200 rounded-md border-blue-700">
                                      {index === 0
                                        ? `${formatTime(
                                          appointment.durationFromHome
                                        )} from home`
                                        : appointment.duration === "0"
                                          ? "Same Location"
                                          : `${formatTime(
                                            appointment.duration
                                          )} from previous appointment`}
                                      {index === filteredAppointments.length - 1
                                        ? ` and ${formatTime(
                                          appointment.durationFromHome
                                        )} from home`
                                        : ``}
                                    </span>
                                  </div>
                                </div>
                                {appointment.status === "PUBLISHED" ? (
                                  <Tooltip title="Published to Athena">
                                    <div className="flex justify-center items-center w-10 h-10 bg-gray-50 rounded-lg">
                                      <CheckSvg color={"#6FCF97"} />
                                    </div>
                                  </Tooltip>
                                ) : (
                                  user?.permissions?.includes('cc_home.partial_publish') &&
                                  !editable && (
                                    <div className="w-10 h-10">
                                      <input
                                        type="checkbox"
                                        className="w-6 h-6"
                                        checked={appointmentsSelected.includes(
                                          appointment.appointmentId
                                        )}
                                        onChange={() =>
                                          setAppointmentsSelected((prev) =>
                                            prev.includes(
                                              appointment.appointmentId
                                            )
                                              ? prev.filter(
                                                (p) =>
                                                  p !==
                                                  appointment.appointmentId
                                              )
                                              : [
                                                ...prev,
                                                appointment.appointmentId,
                                              ]
                                          )
                                        }
                                        onClick={(e) => {
                                          e.stopPropagation();
                                        }}
                                      />
                                    </div>
                                  )
                                )}
                                {appointment.hasSlotConflict && (
                                  <Tooltip title="Timeslot Conflict">
                                    <IconButton
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevents event bubbling
                                        handleSlotModal(appointment);
                                      }}
                                      className="flex justify-center items-center w-10 h-10 bg-gray-50 rounded-lg"
                                    >
                                      <Icon name="20-alert" color={"#eb5757"} />
                                    </IconButton>
                                  </Tooltip>
                                )}
                              </div>
                              <div className="flex justify-evenly w-full">
                                {!editable ||
                                  // appointment.status === "LOCKED" ||
                                  appointment.status === "PUBLISHED" ||
                                  !user?.permissions?.includes('cc_home.cc_type_edit') ? (
                                  <button
                                    disabled={selectedAppointment || addOpen}
                                    className="text-sm m-0 py-1 px-2 border-[1px] border-primarylightgrey bg-primarylightgrey font-semibold rounded-lg"
                                  >
                                    {appointment.appointmentType.name}
                                  </button>
                                ) : (
                                  <select
                                    onClick={(e) => {
                                      e.stopPropagation();
                                    }}
                                    className="border-[1px] border-primarydarkgrey rounded-lg bg-primarylightgrey"
                                    value={appointment.appointmentType?.id}
                                     
                                    onChange={(e) => {
                                     
                                        // handleVisitType(
                                        //   appointment.appointmentId,
                                        //   e.target.value
                                        // );
                                        setVisitTypeEditConfirmation({
                                          id: appointment.appointmentId,
                                          visitType: e.target.value,
                                        });
                                      
                                    }}
                                  >
                                    {appointmentTypes.map((type) => (
                                      <option key={type.id} value={type.id}>
                                        {type.name}
                                      </option>
                                    ))}
                                  </select>
                                )}
                                {/* <button
                              disabled={selectedAppointment || addOpen}
                              onClick={() => {
                                setSelectedAppointment(appointment);
                              }}
                              className="text-sm m-0 py-1 px-2 border-[1px] font-medium border-primarygrayborder rounded-lg"
                            >
                              Appointment details
                            </button> */}
                                <button
                                  disabled={selectedAppointment || addOpen || !user?.permissions?.includes('cc_home.change_appointment_status')}
                                  className={classNames(
                                    "text-sm m-0 py-1 px-2 bg-white font-semibold rounded-lg flex items-center gap-1",
                                    appointment.visitStatus === "COMPLETED"
                                      ? "text-primarygreen border-[1px] border-primarygreen"
                                      : appointment.visitStatus === "SCHEDULED"
                                        ? "text-primaryyellow border-[1px] border-primaryyellow"
                                        : appointment.visitStatus === "CANCELLED"
                                          ? "text-primaryred border-[1px] border-primaryred"
                                          : appointment.visitStatus === "NOSHOW"
                                            ? "text-primaryorange border-[1px] border-primaryorange"
                                            : "text-primaryblue border-[1px] border-primaryblue"
                                  )}
                                  onClick={(e) => {
                                    e.stopPropagation(); // Prevents event bubbling
                                    setAppointmentToChangeStatus(appointment);
                                    handleStatusModal(appointment.visitStatus);
                                  }}
                                >
                                  {getVisitStatusText(appointment.visitStatus)}
                                </button>
                                <button
                                  disabled={selectedAppointment || addOpen || !user?.permissions?.includes('cc_home.lock_unlock_appointment')}
                                  className={classNames(
                                    "text-sm m-0 py-1 px-2 bg-white font-semibold rounded-lg flex items-center gap-1",
                                    appointment.status === "PUBLISHED"
                                      ? "text-primarygreen border-[1px] border-primarygreen"
                                      : appointment.status === "UNLOCKED"
                                        ? "text-primaryyellow border-[1px] border-primaryyellow"
                                        : "text-primaryblue border-[1px] border-primaryblue"
                                  )}
                                  onClick={(e) => {
                                    e.stopPropagation(); // Prevents event bubbling
                                    setAppointmentToLock(appointment);
                                    handleLockModal();
                                  }}
                                >
                                  {getLockStatusText(appointment.status)}
                                </button>
                                {!["COMPLETED", "CANCELLED"].includes(
                                  appointment.visitStatus
                                ) && (
                                    <button
                                      disabled={selectedAppointment || addOpen || !user?.permissions?.includes('cc_home.cancel_appointment')}
                                      onClick={(e) => {
                                        e.stopPropagation(); // Prevents event bubbling
                                        setAppointmentToCancel(appointment);
                                        handleCancelModal();
                                      }}
                                      className="text-sm flex font-semibold flex-row items-center gap-1 m-0 py-1 px-2 border-[1px] border-primaryred text-primaryred rounded-lg bg-subtlered"
                                    >
                                      <Delete
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                        }}
                                      />
                                      Cancel
                                    </button>
                                  )}
                              </div>
                            </div>
                            {editable && appointment.status !== "PUBLISHED" && user?.permissions?.includes('cc_home.view_resequence_buttons') && (
                              <div
                                className={classNames(
                                  "absolute right-0 flex flex-col justify-between gap-2",
                                  appointment.status === "PUBLISHED"
                                    ? "top-10"
                                    : "top-0"
                                )}
                              >
                                <Tooltip title="Sequence to up">
                                  <button
                                    disabled={!editable || index === 0}
                                    onClick={(e) => {
                                      e.stopPropagation(); // Prevents event bubbling
                                      if (appointment.status === "LOCKED") {
                                        setShowLockedError(true);
                                        return;
                                      }
                                      // const reverseIndex = 0;
                                      const reverseIndex = filteredAppointments
                                        .slice(0, index)
                                        .reverse()
                                        .findIndex(
                                          (appt) => appt.status === "UNLOCKED"
                                        );

                                      const normalIndex =
                                        reverseIndex !== -1
                                          ? index - reverseIndex - 1
                                          : -1;
                                      onDrop(normalIndex, appointment);
                                    }}
                                    className={classNames(
                                      "flex justify-center items-center w-10 h-10 rounded-md transition-all duration-200 ease-in-out bg-primarylightgrey disabled:opacity-50 disabled:cursor-not-allowed"
                                    )}
                                  >
                                    <div>
                                      <Icon
                                        name="20-chevron-up"
                                        color={"#000"}
                                      />
                                    </div>
                                  </button>
                                </Tooltip>
                                <Tooltip title="Sequence to down">
                                  <button
                                    disabled={
                                      !editable ||
                                      index === filteredAppointments.length - 1
                                    }
                                    onClick={(e) => {
                                      e.stopPropagation(); // Prevents event bubbling
                                      if (appointment.status === "LOCKED") {
                                        setShowLockedError(true);
                                        return;
                                      }
                                      // const reverseIndex = 0;
                                      const reverseIndex = filteredAppointments
                                        .slice(index + 1)
                                        .findIndex(
                                          (appt) => appt.status === "UNLOCKED"
                                        );

                                      let normalIndex =
                                        reverseIndex !== -1
                                          ? index + reverseIndex + 1
                                          : -1;
                                      normalIndex =
                                        normalIndex === -1
                                          ? filteredAppointments.length
                                          : normalIndex;
                                      onDrop(normalIndex, appointment);
                                    }}
                                    className={classNames(
                                      "flex justify-center items-center w-10 h-10 rounded-md transition-all duration-200 ease-in-out bg-primarylightgrey disabled:opacity-50 disabled:cursor-not-allowed"
                                    )}
                                  >
                                    <div>
                                      <Icon
                                        name="20-chevron-down"
                                        color={"#000"}
                                      />
                                    </div>
                                  </button>
                                </Tooltip>
                              </div>
                            )}
                          </div>
                          <div className="w-full">
                            <div className="w-full h-[1px] bg-gray-200" />
                            <p className="m-0 mt-2 text-start"></p>
                            <p className="m-0 text-start">
                              <b>Appointment note:</b>{" "}
                              {appointment?.notes?.length > 0
                                ? appointment.notes
                                  ?.map(({ description }) => description)
                                  ?.join(", ")
                                : "NA"}
                            </p>
                            <p className="m-0 text-start">
                              <b>Patient note:</b>{" "}
                              {appointment?.patient?.notes ?? "NA"}
                            </p>
                            <div className="flex gap-2">
                              <p className="m-0 font-bold text-start">
                                Department:{" "}
                              </p>
                              {!editable ||
                                appointment.status === "PUBLISHED" ||
                                appointment.status === "LOCKED" ||
                                !user?.permissions?.includes('cc_home.cc_department_edit') ? (
                                <p className="m-0 text-start">
                                  {departments.find(
                                    (dept) =>
                                      dept.id === appointment?.departmentId
                                  )?.name ?? "NA"}
                                </p>
                              ) : (
                                <select
                                  value={appointment?.departmentId}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                  }}
                                  onChange={(e) => {
                                    handleDepartment(
                                      appointment.appointmentId,
                                      e.target.value
                                    );
                                  }}
                                  className="text-sm m-0 py-1 px-2 border-[1px] border-primarydarkgrey bg-primarylightgrey font-semibold rounded-lg"
                                >
                                  <option value={null}>
                                    Select Department
                                  </option>
                                  {departments.map((department) => (
                                    <option
                                      key={department.id}
                                      value={department.id}
                                    >
                                      {department.name}
                                    </option>
                                  ))}
                                </select>
                              )}
                            </div>
                            <div className="flex justify-between">
                              <p className="m-0">
                                <b>Phone: </b>{" "}
                                {`${appointment.patient?.poc?.phone
                                  ? numberToPhone(
                                    appointment.patient?.poc?.phone
                                  )
                                  : "NA"
                                  }`}
                              </p>
                              <div>
                                {editable &&
                                  appointment.status === "UNLOCKED" &&
                                  user?.permissions?.includes('cc_home.cc_timeslot_edit') ? (
                                  <select
                                    value={moment(
                                      appointment.timeslot,
                                      "hh:mm A"
                                    ).format("HH:mm")}
                                    onChange={(e) => {
                                      e.stopPropagation();
                                      const isConflict =
                                        filteredAppointments.find((appt) => {
                                          return (
                                            appt.appointmentId !==
                                            appointment.appointmentId &&
                                            moment(
                                              appt.timeslot,
                                              "hh:mm a"
                                            ).format("HH:mm") === e.target.value
                                          );
                                        });
                                      setTimeslotEditConfirmation({
                                        id: appointment.appointmentId,
                                        timeslot: e.target.value,
                                        isDoubleBook: isConflict,
                                      });
                                    }}
                                    onClick={(e) => {
                                      e.stopPropagation();
                                    }}
                                  >
                                    <option
                                      value={moment(
                                        appointment.timeslot,
                                        "hh:mm A"
                                      ).format("HH:mm")}
                                    >
                                      {moment(
                                        appointment.timeslot,
                                        "hh:mm A"
                                      ).format("hh:mm A")}
                                    </option>
                                    {timeslots.map((timeslot) => (
                                      <option key={timeslot} value={timeslot}>
                                        {moment(timeslot, "HH:mm").format(
                                          "hh:mm A"
                                        )}
                                      </option>
                                    ))}
                                  </select>
                                ) : (
                                  <div className="flex gap-1 items-center m-0">
                                    <span>{appointment?.timeslot}</span>
                                    {appointment?.patientLocalTime !==
                                      appointment?.timeslot && (
                                        <Tooltip
                                          title={`Timeslot in patient timezone: ${appointment?.patientLocalTime}`}
                                        >
                                          <button className="p-0 m-0">
                                            <InfoSvg color="#f00" />
                                          </button>
                                        </Tooltip>
                                      )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </button>
                      </div>
                      <DropArea onDrop={() => onDrop(index + 1)} />
                    </>
                  ))}
                </div>
              )}
              {selectedProvider &&
                appointments[moment(selectedDate).format("YYYY-MM-DD")]
                  ?.length > 0 &&
                user?.organisation?.data?.isEnterprise &&
                user?.permissions?.includes('cc_home.publish_to_ehr') && (
                  <div className="p-2 d-flex justify-content-center align-items-center">
                    <CustomButton
                      className="font-semibold publish-btn"
                      disabled={editable}
                      // disabled={!isPublishEnabled}
                      onClick={onPublishClick}
                    >
                      Publish to Athena
                    </CustomButton>
                  </div>
                )}
            </div>
          </>
        )}
        {selectedTab === "Messenger" && (
          <div>
            <Chat isFullScreen={false} />
          </div>
        )}
      </div>
      {selectedAppointment && (
        <div className="overflow-auto z-50 opacity-100">
          <AppointmentSelectModal
            selectedProvider={selectedProvider}
            setRecallSchedule={setRecallSchedule}
            onClose={handleClearSelectedAppointment}
            allow={
              {
                create_patient_note: user?.permissions?.includes('cc_home.create_patient_note'),
                view_patient_note: user?.permissions?.includes('cc_home.view_patient_note'),
                update_patient_note: user?.permissions?.includes('cc_home.update_patient_note'),
                create_appointment_note: user?.permissions?.includes('cc_home.create_appointment_note'),
                update_appointment_note: user?.permissions?.includes('cc_home.update_appointment_note'),
                delete_appointment_note: user?.permissions?.includes('cc_home.delete_appointment_note'),
                view_appointment_note: user?.permissions?.includes('cc_home.view_appointment_note'),
              }
            }
          />
        </div>
      )}
      {filterOptions && selectedProvider && addOpen && (
        <div className="z-50 opacity-100">
          <AppointmentAddModal
            selectedProvider={selectedProvider}
            addOpen={addOpen}
            setAddOpen={setAddOpen}
            weeks={null}
            onAdd={() => { }}
            filterOptions={filterOptions}
            setRecallSchedule={setRecallSchedule}
            selectedDate={selectedDate}
            created_from={APPOINTMENT_CREATED_FROM.CC_HOME}
          />
        </div>
      )}
      {/* <AppointmentCancelModal
        open={openCancelModal}
        handleCancelModal={handleCancelModal}
        handleCancel={handleCancel}
      /> */}
      {openCancelModal && (
        <VisitCancelModal
          open={openCancelModal}
          handleClose={handleCancelModal}
          handleCancel={handleCancel}
          selectedVisit={appointmentToCancel}
        />
      )}
      <AppointmentLockModal
        open={openLockModal}
        handleLockModal={handleLockModal}
        handleLock={handleLock}
        status={appointmentToLock?.status}
      />
      {/* {targetIndex != null && (
        <AppointmentSequence
          open={targetIndex != null}
          handleSequenceModal={handleSequenceModal}
          handleSequence={handleDrop}
          appointment={draggingAppointment}
          targetAppointment={
            appointments?.[draggingAppointment?.visitDate]?.[targetIndex]
          }
          targetIndex={targetIndex}
          currentIndex={
            appointments?.[draggingAppointment?.visitDate]?.findIndex(
              (app) => app.appointmentId === draggingAppointment.appointmentId
            ) ?? -1
          }
        />
      )} */}
      {appointmentToChangeStatus && (
        <AppointmentStatusModal
          open={openStatusModal}
          handleCancel={handleStatusModal}
          handleSubmit={handleChangeStatus}
          status={appointmentToChangeStatus?.visitStatus}
        />
      )}
      {isPublish && weeks !== null && (
        <PublishAppointmentModal
          publishOpen={isPublish}
          setPublishOpen={setIsPublish}
          weeks={weeks}
          setSuccessCard={setSuccessCard}
          selectedProvider={selectedProvider}
          user={user}
          setRecallSchedule={setRecallSchedule}
          appointmentsSelected={appointmentsSelected}
          setAppointmentsSelected={setAppointmentsSelected}
          filteredAppointments={filteredAppointments}
        />
      )}
      {appointmentToChangeTimeslot && (
        <AppointmentConflictModal
          open={appointmentToChangeTimeslot}
          handleSlotModal={handleSlotModal}
          handleChangeSlot={handleChangeSlot}
          selected={appointmentToChangeTimeslot}
        />
      )}
      <ReusableModal open={openOptimise && dataToOptimise !== null} hideHeader>
        <div className="flex flex-col w-96">
          <div className="flex flex-row justify-between items-center p-3">
            <p className="m-0 text-lg font-bold">Optimize Route?</p>
            <Tooltip title="Close">
              <button
                disabled={optimiseLoading}
                onClick={() => {
                  handleOptimise();
                  setOptimiseError(null);
                }}
                className={classNames(
                  "flex border border-black rounded-full",
                  optimiseLoading && "opacity-40"
                )}
              >
                <CloseSvg />
              </button>
            </Tooltip>
          </div>
          <p className="px-3 py-4 m-0 border-t border-b border-primarygrayborder">
            We will optimize this day's schedule to reduce the mileage. Press
            Optimize to confirm this action.
          </p>
          {optimiseError != null && (
            <p className="px-3 py-1 m-0 text-sm font-medium text-center text-red-400 border-b border-primarygrayborder">
              <span className="m-0 font-bold">Error</span>: {optimiseError}
            </p>
          )}
          <div className="p-3 ml-auto">
            <button
              disabled={optimiseLoading}
              onClick={() => {
                handleOptimiseCall(
                  dataToOptimise?.date,
                  dataToOptimise?.providerId
                );
              }}
              className={classNames(
                "px-3 py-2 font-bold text-white rounded-md bg-primaryblue",
                optimiseLoading && "opacity-40"
              )}
            >
              Optimize
            </button>
          </div>
        </div>
      </ReusableModal>
      <ReusableModal open={openOptimiseBlocked} hideHeader>
        <div className="flex flex-col w-96">
          <div className="flex flex-row justify-between items-center p-3">
            <p className="m-0 text-lg font-bold">Cannot optimize route</p>
            <Tooltip title="Close">
              <button
                onClick={() => setOpenOptimiseBlocked(false)}
                className="flex rounded-full border border-black"
              >
                <CloseSvg />
              </button>
            </Tooltip>
          </div>
          <p className="px-3 py-4 m-0 border-t border-b border-primarygrayborder">
            This day has locked or published appointments. Unlock or unpublish
            them to optimize the route.
          </p>
        </div>
      </ReusableModal>
    
      {showError != null && (
        <InfoModal
          open={showError != null}
          errors={showError}
          title="Something went wrong!"
          type={"error"}
          handleClose={() => {
            setShowError(null);
          }}
        />
      )}

      {error != null && (
        <InfoModal
          open={error != null}
          subtext={error}
          title="Timeslot Update"
          type={"error"}
          handleClose={() => {
            setError(null);
            let prevAppt = appointments[
              moment(selectedDate).format("YYYY-MM-DD")
            ].filter(
              (appt) =>
                appt.changedTimeslot ||
                appt.changedDepartment ||
                appt.changedVisitType
            );
            if (prevAppt[0].changedTimeslot) {
              prevAppt[0].changedTimeslot = false;
              const oldTimeslot = prevAppt[0]?.oldTimeslot || "";
              prevAppt[0].timeslot = oldTimeslot;
              prevAppt[0].patientLocalTime = oldTimeslot;
            }
            if (prevAppt[0].changedVisitType) {
              prevAppt[0].changedVisitType = false;
              const oldAppointmentType = prevAppt[0]?.oldAppointmentType || "";
              prevAppt[0].appointmentType = oldAppointmentType;
            }
            setAppointments((prev) => {
              return {
                ...prev,
              };
            });
          }}
          primaryClick={(e) => {
            if (secondaryTitle) {
              handleEditSave(e, true, null);
            }
            setError(null);
            if (primaryTitle == "Okay" && !secondaryTitle) {
              let prevAppt = appointments[
                moment(selectedDate).format("YYYY-MM-DD")
              ].filter(
                (appt) =>
                  appt.changedTimeslot ||
                  appt.changedDepartment ||
                  appt.changedVisitType
              );
              if (prevAppt[0].changedTimeslot) {
                prevAppt[0].changedTimeslot = false;
                const oldTimeslot = prevAppt[0]?.oldTimeslot || "";
                prevAppt[0].timeslot = oldTimeslot;
                prevAppt[0].patientLocalTime = oldTimeslot;
              }
              if (prevAppt[0].changedVisitType) {
                prevAppt[0].changedVisitType = false;
                const oldAppointmentType = prevAppt[0]?.oldAppointmentType || "";
                prevAppt[0].appointmentType = oldAppointmentType;
              }
              setAppointments((prev) => {
                return {
                  ...prev,
                };
              });
            }
          }}
          secondaryClick={() => {
            setError(null);
            let prevAppt = appointments[
              moment(selectedDate).format("YYYY-MM-DD")
            ].filter(
              (appt) =>
                appt.changedTimeslot ||
                appt.changedDepartment ||
                appt.changedVisitType
            );
            if (prevAppt[0].changedTimeslot) {
              prevAppt[0].changedTimeslot = false;
              const oldTimeslot = prevAppt[0]?.oldTimeslot || "";
              prevAppt[0].timeslot = oldTimeslot;
              prevAppt[0].patientLocalTime = oldTimeslot;
            }
            if (prevAppt[0].changedVisitType) {
              prevAppt[0].changedVisitType = false;
              const oldAppointmentType = prevAppt[0]?.oldAppointmentType || "";
              prevAppt[0].appointmentType = oldAppointmentType;
            }
            setAppointments((prev) => {
              return {
                ...prev,
              };
            });
          }}
          secondaryTitle={secondaryTitle}
          primaryTitle={primaryTitle}
        />
      )}

      {openBulkSchedule && (
        <BulkActionsModal
          isOpen={openBulkSchedule}
          onClose={() => {
            handleBulkSchedule({});
          }}
          scheduleData={dataToBulkSchedule}
          selectedProvider={selectedProvider}
          setRecallSchedule={setRecallSchedule}
          count={count}
          onMonthChange={(val) =>
            onMonthChange({
              activeStartDate: val,
            })
          }
        />
      )}
      {timeslotEditConfirmation !== null && (
        <InfoModal
          open={timeslotEditConfirmation !== null}
          title={
            timeslotEditConfirmation?.isDoubleBook
              ? "Schedule Conflict"
              : "Timeslot update"
          }
          subtext={
            timeslotEditConfirmation?.isDoubleBook
              ? "The selected time slot is already occupied by another appointment. Proceeding will create a double booking for this provider. Do you want to proceed anyway?"
              : "Are you sure you want to change the timeslot?"
          }
          primaryTitle={
            timeslotEditConfirmation?.isDoubleBook
              ? "Proceed with Double Booking"
              : "Yes, Update"
          }
          secondaryTitle={
            timeslotEditConfirmation?.isDoubleBook
              ? "Choose Different Time"
              : "No"
          }
          handleClose={() => {
            setTimeslotEditConfirmation(null);
          }}
          primaryClick={(e) => {
            setTimeslotEditConfirmation(null);
            handleTimeslot(
              timeslotEditConfirmation?.id,
              timeslotEditConfirmation?.timeslot,
              timeslotEditConfirmation?.isDoubleBook,
              true
            );
            //  handleEditSave();
          }}
          secondaryClick={() => {
            setTimeslotEditConfirmation(null);
          }}
          buttonCustomWidth="w-full"
        />
      )}
      {visitTypeEditConfirmation !== null && (
        <InfoModal
          open={visitTypeEditConfirmation !== null}
          title={"Visit Type update"}
          subtext={"Are you sure you want to change the visit type?"}
          primaryTitle={
            "Yes, Update"
          }
          secondaryTitle={"No"}
          handleClose={() => {
            setVisitTypeEditConfirmation(null);
          }}
          primaryClick={(e) => {
            setVisitTypeEditConfirmation(null);
            handleVisitType(
              visitTypeEditConfirmation?.id,
              visitTypeEditConfirmation?.visitType,
              true
            );
            //  handleEditSave();
          }}
          secondaryClick={() => {
            setVisitTypeEditConfirmation(null);
          }}
          buttonCustomWidth="w-full"
        />
      )}
      {showLockedError != null && (
        <InfoModal
          open={showLockedError != null}
          title="Locked Appointments resequence"
          subtext="You cannot resequence locked appointments. Please unlock the appointments to resequence them."
          type={"info"}
          handleClose={() => {
            setShowLockedError(null);
          }}
        />
      )}
    </div>
  );
};

export default CommandCenterV2;